import React, { useState, useEffect, useRef } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useParams, useNavigate } from "react-router-dom";
import AthleteProfileCard from "../component/AthleteProfileCard";
import { AthleteTabMenu } from "./AthleteTabMenu";
import SingleSelectExerciseList from "../component/SingleSelectExerciseList";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import {
  MdAdd,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { RiDeleteBin4Line } from "react-icons/ri";
import { CiSearch } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { FaChevronRight } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

const SaveTempIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.3337 13.9993V9.33268C11.3337 9.15587 11.2634 8.9863 11.1384 8.86128C11.0134 8.73625 10.8438 8.66602 10.667 8.66602H5.33366C5.15685 8.66602 4.98728 8.73625 4.86225 8.86128C4.73723 8.9863 4.66699 9.15587 4.66699 9.33268V13.9993"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.66699 2V4.66667C4.66699 4.84348 4.73723 5.01305 4.86225 5.13807C4.98728 5.2631 5.15685 5.33333 5.33366 5.33333H10.0003"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

// Helper to format a date nicely
const getFormattedDate = (dateStr) => {
  if (!dateStr) return "Invalid date";

  // Handle both YYYY-MM-DD and ISO format strings
  const dateOnly = dateStr.split("T")[0]; // Remove time if present
  const [year, month, day] = dateOnly.split("-").map(Number);

  if (!year || !month || !day) return "Invalid date";

  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
};

export const AdminAthleteStrengthWorkout = () => {
  const { staff } = useStaffAuthContext();
  const { athlete_id } = useParams();
  const navigate = useNavigate();

  const [athlete, setAthlete] = useState(null);
  const [weeks, setWeeks] = useState([]);

  // Immediately after defining weeks, add:
  console.log("Current weeks data:", weeks);

  const [selectedMonth, setSelectedMonth] = useState(() =>
    new Date().toISOString().slice(0, 7),
  );
  const [selectedDayInfo, setSelectedDayInfo] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [newWeekStartDate, setNewWeekStartDate] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [activeWeekTab, setActiveWeekTab] = useState(0);

  const [savingAll, setSavingAll] = useState(false); // New state for Save All button loading

  const [showAddExerciseForm, setShowAddExerciseForm] = useState(false);
  const [exerciseLibrary, setExerciseLibrary] = useState([]);
  const [selectedExerciseId, setSelectedExerciseId] = useState("");

  const [openIndexes, setOpenIndexes] = useState([]);

  const [showAddSupersetForm, setShowAddSupersetForm] = useState(false);
  const [newSupersetTitle, setNewSupersetTitle] = useState("");

  const [showSupersetAddForm, setShowSupersetAddForm] = useState(null); // store item._id
  const [selectedSupersetExerciseId, setSelectedSupersetExerciseId] =
    useState("");

  const [openSupersetExercise, setOpenSupersetExercise] = useState({
    itemId: null,
    sIdx: null,
  });

  //circuit
  const [showAddCircuitForm, setShowAddCircuitForm] = useState(false);
  const [newCircuitTitle, setNewCircuitTitle] = useState("");

  const [showCircuitAddForm, setShowCircuitAddForm] = useState(null); // store item._id
  const [selectedCircuitExerciseId, setSelectedCircuitExerciseId] =
    useState("");

  const [openCircuitExercise, setOpenCircuitExercise] = useState({
    itemId: null,
    sIdx: null,
  });

  //reorder top level
  const [reorderMode, setReorderMode] = useState(false);

  const [ssreorderMode, setSSReorderMode] = useState(false);
  const [ccreorderMode, setCCReorderMode] = useState(false);

  // Load athlete data
  useEffect(() => {
    const fetchAthlete = async () => {
      try {
        const res = await fetch(`${API_URL.GET_ATHLETE_BY_ID}/${athlete_id}`, {
          headers: { Authorization: `Bearer ${staff.token}` },
        });
        const data = await res.json();
        if (res.ok) setAthlete(data);
      } catch (err) {
        console.error("Failed to load athlete", err);
      }
    };
    if (athlete_id && staff?.token) fetchAthlete();
  }, [athlete_id, staff.token]);

  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const res = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        });
        const data = await res.json();
        console.log(data);
        if (res.ok && data?.exercises) {
          setExerciseLibrary(data.exercises);
        } else {
          console.error("Error loading exercises");
        }
      } catch (err) {
        console.error("Failed to fetch exercise library", err);
      }
    };

    if (staff?.token) fetchExercises();
  }, [staff?.token]);

  // Load strength workout weeks on page load or when selectedMonth changes
  useEffect(() => {
    if (!athlete_id || !staff?.token) return;

    const fetchWeeks = async () => {
      try {
        // const url = new URL(API_URL.GET_ATHLETE_STRENGTHWORKOUT_WEEKS);
        // url.searchParams.append("athlete_id", athlete_id);
        // url.searchParams.append("month", selectedMonth);

        const url = `${API_URL.GET_ATHLETE_STRENGTHWORKOUT_WEEKS}?athlete_id=${athlete_id}&month=${selectedMonth}`;

        const res = await fetch(url.toString(), {
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setWeeks(data.data || []);
          setActiveWeekTab(0);
          setSelectedDayInfo(null);
        } else {
          console.error("Failed to load weeks:", data.error);
          setWeeks([]);
        }
      } catch (err) {
        console.error("Error fetching weeks:", err);
        setWeeks([]);
      }
    };

    fetchWeeks();
  }, [athlete_id, staff?.token, selectedMonth]);

  // Save new week to API
  const handleSaveNewWeek = async () => {
    // const date = new Date(newWeekStartDate);

    const [year, month, day] = newWeekStartDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    if (date.getDay() !== 0) {
      alert("Start date must be a Sunday.");
      return;
    }

    const newWeekPayload = {
      athlete_id,
      week_start_date: newWeekStartDate,
    };

    try {
      const res = await fetch(API_URL.SAVE_ATHLETE_STRENGTHWORKOUT_WEEK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify(newWeekPayload),
      });

      const data = await res.json();

      if (res.ok) {
        // Add new week returned from backend to weeks state
        setWeeks((prev) => [...prev, data.data]);
        setSuccessMessage("Week added successfully.");
        setNewWeekStartDate("");
        setShowDatePicker(false);
        setActiveWeekTab(weeks.length); // select newly added week tab
        setSelectedDayInfo(null);
      } else {
        alert(data.error || "Failed to save new week");
      }
    } catch (err) {
      console.error("Error saving new week:", err);
      alert("Server error while saving new week");
    }
  };

  const handleCloseNewWeek = () => {
    setShowDatePicker(false);
  };

  const handleDeleteWeek = async (weekId) => {
    if (!window.confirm("Are you sure you want to delete this week?")) return;

    try {
      const res = await fetch(
        `${API_URL.DELETE_ATHLETE_STRENGTHWORKOUT_WEEK}/${weekId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        },
      );

      const data = await res.json();

      if (res.ok) {
        // Remove deleted week from weeks state
        setWeeks((prevWeeks) =>
          prevWeeks.filter((week) => week._id !== weekId),
        );
        setSuccessMessage("Week deleted successfully.");
        // Reset selected tab if needed
        if (activeWeekTab >= weeks.length - 1) {
          setActiveWeekTab(Math.max(0, activeWeekTab - 1));
        }
        setSelectedDayInfo(null);
      } else {
        alert(data.error || "Failed to delete week");
      }
    } catch (err) {
      console.error("Failed to delete week:", err);
      alert("Server error deleting week");
    }
  };

  // Save All handler - new method
  const handleSaveAllWeeks = async () => {
    if (!athlete_id || !weeks || weeks.length === 0) {
      alert("No weeks data to save.");
      return;
    }

    setSavingAll(true);
    setSuccessMessage("");

    // Construct weeksData as backend expects (keys = week_start_date)
    const weeksData = {};
    weeks.forEach((week) => {
      weeksData[week.week_start_date] = {
        days: week.days,
      };
    });

    try {
      const res = await fetch(API_URL.SAVE_ATHLETE_STRENGTHWORKOUT_DATA, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({
          athlete_id,
          weeksData,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccessMessage("All weeks saved successfully!");
        // Optionally, refresh weeks from backend here to sync latest
      } else {
        alert(data.error || "Failed to save all weeks.");
      }
    } catch (err) {
      console.error("Error saving all weeks:", err);
      alert("Server error while saving all weeks.");
    } finally {
      setSavingAll(false);
    }
  };

  const handleAddExercise = () => {
    if (!selectedDayInfo) {
      alert("Please select a day to add exercise.");
      return;
    }
    if (!selectedExerciseId) {
      alert("Please select an exercise.");
      return;
    }

    // Find the exercise data by id from library
    const exerciseToAdd = exerciseLibrary.find(
      (ex) => ex._id === selectedExerciseId,
    );
    if (!exerciseToAdd) {
      alert("Selected exercise not found.");
      return;
    }

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      // Clone items array or initialize if missing
      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      // Determine next order_id (max order_id in items + 1)
      const maxOrderId = selectedDay.items.reduce(
        (max, item) => Math.max(max, item.order_id),
        0,
      );

      // Add new exercise item
      selectedDay.items.push({
        _id: generateUniqueId(), // <== assign temp unique ID here
        type: "exercise",
        order_id: maxOrderId + 1,
        exercise: {
          exercise_id: exerciseToAdd._id,
          sets: [],
          one_rm: 0,
        },
      });

      // Update days array
      newDays[selectedDayInfo.dayIdx] = selectedDay;

      // Update week with new days array
      selectedWeek.days = newDays;

      // Update weeks array
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });

    setSelectedExerciseId(null);
    setShowAddExerciseForm(false);
  };

  //this is for all delete of top level workout i.e exercise, superset or circuit
  const handleDeleteExercise = (weekIdx, dayIdx, itemIdx) => {
    const updatedWeeks = [...filteredWeeks];
    updatedWeeks[weekIdx].days[dayIdx].items.splice(itemIdx, 1);
    setWeeks(updatedWeeks);
    // no API call here, rely on Save All later
  };

  const updateSet = (weekIdx, dayIdx, itemIdx, setIdx, field, value) => {
    setWeeks((prevWeeks) => {
      // Deep clone just the relevant parts
      const newWeeks = prevWeeks.map((week, wIdx) => {
        if (wIdx !== weekIdx) return week;

        return {
          ...week,
          days: week.days.map((day, dIdx) => {
            if (dIdx !== dayIdx) return day;

            return {
              ...day,
              items: day.items.map((item, iIdx) => {
                if (iIdx !== itemIdx) return item;

                // Update the sets array immutably
                const newSets = item.exercise.sets.map((set, sIdx) => {
                  if (sIdx !== setIdx) return set;
                  return { ...set, [field]: value };
                });

                return {
                  ...item,
                  exercise: { ...item.exercise, sets: newSets },
                };
              }),
            };
          }),
        };
      });

      return newWeeks;
    });
  };

  const addSet = (weekIdx, dayIdx, itemIdx) => {
    setWeeks((prevWeeks) => {
      const newWeeks = prevWeeks.map((week, wIdx) => {
        if (wIdx !== weekIdx) return week;

        return {
          ...week,
          days: week.days.map((day, dIdx) => {
            if (dIdx !== dayIdx) return day;

            return {
              ...day,
              items: day.items.map((item, iIdx) => {
                if (iIdx !== itemIdx) return item;

                return {
                  ...item,
                  exercise: {
                    ...item.exercise,
                    sets: [
                      ...item.exercise.sets,
                      {
                        reps: "",
                        weight: "",
                        unit: "%",
                        time: "",
                        goal: "",
                        rest: "",
                        notes: "",
                      },
                    ],
                  },
                };
              }),
            };
          }),
        };
      });

      return newWeeks;
    });
  };

  const deleteSet = (weekIdx, dayIdx, itemIdx, setIdx) => {
    setWeeks((prevWeeks) => {
      const newWeeks = prevWeeks.map((week, wIdx) => {
        if (wIdx !== weekIdx) return week;

        return {
          ...week,
          days: week.days.map((day, dIdx) => {
            if (dIdx !== dayIdx) return day;

            return {
              ...day,
              items: day.items.map((item, iIdx) => {
                if (iIdx !== itemIdx) return item;

                const newSets = item.exercise.sets.filter(
                  (_, sIdx) => sIdx !== setIdx,
                );

                return {
                  ...item,
                  exercise: { ...item.exercise, sets: newSets },
                };
              }),
            };
          }),
        };
      });

      return newWeeks;
    });
  };

  //superset related

  const generateUniqueId = () =>
    `temp-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

  const handleAddSuperset = () => {
    if (!selectedDayInfo) {
      alert("Please select a day to add superset.");
      return;
    }

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const maxOrderId = selectedDay.items.reduce(
        (max, item) => Math.max(max, item.order_id || 0),
        0,
      );

      const newSuperset = {
        _id: generateUniqueId(), // <== assign temp unique ID here
        type: "superset",
        order_id: maxOrderId + 1,
        superset: {
          title: newSupersetTitle || "New Superset",
          exercises: [],
        },
      };

      selectedDay.items.push(newSuperset);
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });

    setNewSupersetTitle(null);
    setShowAddSupersetForm(false);
  };

  const handleAddSupersetExercise = (supersetId) => {
    if (!selectedSupersetExerciseId) return;

    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];

      // Deep copy the selected week and day
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      // Find superset item by id
      const supersetItemIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetItemIndex === -1) return prevWeeks;

      // Deep copy superset item and exercises array
      const supersetItem = { ...selectedDay.items[supersetItemIndex] };
      supersetItem.superset = { ...supersetItem.superset };
      supersetItem.superset.exercises = [
        ...(supersetItem.superset.exercises || []),
      ];

      // Check for duplicate (optional)
      if (
        supersetItem.superset.exercises.some(
          (ex) => ex.exercise_id === selectedSupersetExerciseId,
        )
      ) {
        alert("Exercise already exists in this superset.");
        return prevWeeks;
      }

      supersetItem.superset.exercises.push({
        _id: generateUniqueId(),
        exercise_id: selectedSupersetExerciseId,
        sets: [],
        one_rm: 0,
      });

      selectedDay.items[supersetItemIndex] = supersetItem;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });

    setSelectedSupersetExerciseId(null);
    setShowSupersetAddForm(null);
  };

  const updateSupersetSet = (supersetId, exerciseIdx, setIdx, field, value) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const supersetItemIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetItemIndex === -1) return prevWeeks;

      const supersetItem = { ...selectedDay.items[supersetItemIndex] };
      supersetItem.superset = { ...supersetItem.superset };
      supersetItem.superset.exercises = [
        ...(supersetItem.superset.exercises || []),
      ];

      const exercise = { ...supersetItem.superset.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      const set = { ...exercise.sets[setIdx] };
      set[field] = value;

      exercise.sets[setIdx] = set;
      supersetItem.superset.exercises[exerciseIdx] = exercise;
      selectedDay.items[supersetItemIndex] = supersetItem;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const addSupersetSet = (supersetId, exerciseIdx) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const supersetItemIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetItemIndex === -1) return prevWeeks;

      const supersetItem = { ...selectedDay.items[supersetItemIndex] };
      supersetItem.superset = { ...supersetItem.superset };
      supersetItem.superset.exercises = [
        ...(supersetItem.superset.exercises || []),
      ];

      const exercise = { ...supersetItem.superset.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      exercise.sets.push({
        reps: "",
        weight: "",
        unit: "",
        time: "",
        goal: "",
        rest: "",
        notes: "",
      });

      supersetItem.superset.exercises[exerciseIdx] = exercise;
      selectedDay.items[supersetItemIndex] = supersetItem;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const deleteSupersetSet = (supersetId, exerciseIdx, setIdx) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const supersetItemIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetItemIndex === -1) return prevWeeks;

      const supersetItem = { ...selectedDay.items[supersetItemIndex] };
      supersetItem.superset = { ...supersetItem.superset };
      supersetItem.superset.exercises = [
        ...(supersetItem.superset.exercises || []),
      ];

      const exercise = { ...supersetItem.superset.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      exercise.sets.splice(setIdx, 1);

      supersetItem.superset.exercises[exerciseIdx] = exercise;
      selectedDay.items[supersetItemIndex] = supersetItem;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const handleDeleteSupersetExercise = (supersetId, exerciseUniqueId) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const supersetItemIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetItemIndex === -1) return prevWeeks;

      const supersetItem = { ...selectedDay.items[supersetItemIndex] };
      supersetItem.superset = { ...supersetItem.superset };

      supersetItem.superset.exercises = supersetItem.superset.exercises.filter(
        (ex) => ex._id !== exerciseUniqueId,
      );

      selectedDay.items[supersetItemIndex] = supersetItem;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  //end superset

  //circuit handlers

  const handleAddCircuit = () => {
    if (!selectedDayInfo) {
      alert("Please select a day to add circuit.");
      return;
    }

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const maxOrderId = selectedDay.items.reduce(
        (max, item) => Math.max(max, item.order_id || 0),
        0,
      );

      const newCircuit = {
        _id: generateUniqueId(), // <== assign temp unique ID here
        type: "circuit",
        order_id: maxOrderId + 1,
        circuit: {
          title: newCircuitTitle || "New Circuit", // assume you have newCircuitTitle state
          exercises: [],
        },
      };

      selectedDay.items.push(newCircuit);
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });

    setNewCircuitTitle(null); // reset your title input
    setShowAddCircuitForm(false); // hide form modal
  };

  // Add new circuit exercise to item.circuit.exercises
  const handleAddCircuitExercise = (itemId) => {
    if (!selectedCircuitExerciseId) return;
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const itemIndex = selectedDay.items.findIndex(
        (item) => item._id === itemId,
      );
      if (itemIndex === -1) return prevWeeks;

      const item = { ...selectedDay.items[itemIndex] };
      item.circuit = { ...item.circuit };
      item.circuit.exercises = [...(item.circuit.exercises || [])];

      // Optional: Check for duplicate exercise_id
      if (
        item.circuit.exercises.some(
          (ex) => ex.exercise_id === selectedCircuitExerciseId,
        )
      ) {
        alert("Exercise already exists in this circuit.");
        return prevWeeks;
      }

      item.circuit.exercises.push({
        _id: generateUniqueId(),
        exercise_id: selectedCircuitExerciseId,
        sets: [],
        one_rm: 0,
      });

      selectedDay.items[itemIndex] = item;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });

    setSelectedCircuitExerciseId("");
    setShowCircuitAddForm(null);
  };

  const updateCircuitSet = (itemId, exerciseIdx, setIdx, field, value) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const itemIndex = selectedDay.items.findIndex(
        (item) => item._id === itemId,
      );
      if (itemIndex === -1) return prevWeeks;

      const item = { ...selectedDay.items[itemIndex] };
      item.circuit = { ...item.circuit };
      item.circuit.exercises = [...(item.circuit.exercises || [])];

      const exercise = { ...item.circuit.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      const set = { ...exercise.sets[setIdx] };
      set[field] = value;

      exercise.sets[setIdx] = set;
      item.circuit.exercises[exerciseIdx] = exercise;
      selectedDay.items[itemIndex] = item;

      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const addCircuitSet = (itemId, exerciseIdx) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const itemIndex = selectedDay.items.findIndex(
        (item) => item._id === itemId,
      );
      if (itemIndex === -1) return prevWeeks;

      const item = { ...selectedDay.items[itemIndex] };
      item.circuit = { ...item.circuit };
      item.circuit.exercises = [...(item.circuit.exercises || [])];

      const exercise = { ...item.circuit.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      exercise.sets.push({
        reps: "",
        weight: "",
        unit: "",
        time: "",
        goal: "",
        rest: "",
        notes: "",
      });

      item.circuit.exercises[exerciseIdx] = exercise;
      selectedDay.items[itemIndex] = item;

      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const deleteCircuitSet = (itemId, exerciseIdx, setIdx) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const itemIndex = selectedDay.items.findIndex(
        (item) => item._id === itemId,
      );
      if (itemIndex === -1) return prevWeeks;

      const item = { ...selectedDay.items[itemIndex] };
      item.circuit = { ...item.circuit };
      item.circuit.exercises = [...(item.circuit.exercises || [])];

      const exercise = { ...item.circuit.exercises[exerciseIdx] };
      exercise.sets = [...(exercise.sets || [])];

      exercise.sets.splice(setIdx, 1);

      item.circuit.exercises[exerciseIdx] = exercise;
      selectedDay.items[itemIndex] = item;

      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const handleDeleteCircuitExercise = (itemId, exerciseUniqueId) => {
    if (!selectedDayInfo) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[selectedDayInfo.weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[selectedDayInfo.dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const itemIndex = selectedDay.items.findIndex(
        (item) => item._id === itemId,
      );
      if (itemIndex === -1) return prevWeeks;

      const item = { ...selectedDay.items[itemIndex] };
      item.circuit = { ...item.circuit };

      item.circuit.exercises = item.circuit.exercises.filter(
        (ex) => ex._id !== exerciseUniqueId,
      );

      selectedDay.items[itemIndex] = item;
      newDays[selectedDayInfo.dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[selectedDayInfo.weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  //reorder logic

  const handleItemDragEnd = (event, weekIdx, dayIdx) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setWeeks((prevWeeks) => {
      const newWeeks = [...prevWeeks];
      const selectedWeek = { ...newWeeks[weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[dayIdx] };

      selectedDay.items = selectedDay.items ? [...selectedDay.items] : [];

      const oldIndex = selectedDay.items.findIndex(
        (item) => (item._id || item.tempId) === active.id,
      );
      const newIndex = selectedDay.items.findIndex(
        (item) => (item._id || item.tempId) === over.id,
      );

      if (oldIndex === -1 || newIndex === -1) return prevWeeks;

      // Remove the dragged item
      const movedItem = selectedDay.items.splice(oldIndex, 1)[0];
      // Insert dragged item at new position
      selectedDay.items.splice(newIndex, 0, movedItem);

      // Update order_id if you want
      selectedDay.items.forEach((item, idx) => {
        item.order_id = idx + 1;
      });

      newDays[dayIdx] = selectedDay;
      selectedWeek.days = newDays;
      newWeeks[weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const handleSupersetReorderEnd = (event, weekIdx, dayIdx, supersetId) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setWeeks((prevWeeks) => {
      // Copy weeks array
      const newWeeks = [...prevWeeks];

      // Copy target week and day
      const selectedWeek = { ...newWeeks[weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[dayIdx] };

      if (!selectedDay.items) return prevWeeks;

      // Find the superset item index in the day
      const supersetIndex = selectedDay.items.findIndex(
        (item) => item._id === supersetId,
      );
      if (supersetIndex === -1) return prevWeeks;

      // Copy the superset item and its exercises
      const supersetItem = { ...selectedDay.items[supersetIndex] };
      const exercises = supersetItem.superset?.exercises
        ? [...supersetItem.superset.exercises]
        : [];

      // Find indexes of the dragged item and the item it is dropped over
      const activeIndex = exercises.findIndex(
        (ex) => String(ex._id) === String(active.id),
      );
      const overIndex = exercises.findIndex(
        (ex) => String(ex._id) === String(over.id),
      );

      if (activeIndex === -1 || overIndex === -1) return prevWeeks;

      // Reorder exercises array
      const [movedExercise] = exercises.splice(activeIndex, 1);
      exercises.splice(overIndex, 0, movedExercise);

      // Update superset exercises immutably
      supersetItem.superset = {
        ...supersetItem.superset,
        exercises,
      };

      // Replace the superset item in the day items array
      const newItems = [...selectedDay.items];
      newItems[supersetIndex] = supersetItem;

      // Replace the day with updated items
      newDays[dayIdx] = {
        ...selectedDay,
        items: newItems,
      };

      // Replace the week days
      selectedWeek.days = newDays;
      newWeeks[weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  const handleCircuitReorderEnd = (event, weekIdx, dayIdx, circuitId) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setWeeks((prevWeeks) => {
      // Copy weeks array
      const newWeeks = [...prevWeeks];

      // Copy target week and day
      const selectedWeek = { ...newWeeks[weekIdx] };
      const newDays = [...selectedWeek.days];
      const selectedDay = { ...newDays[dayIdx] };

      if (!selectedDay.items) return prevWeeks;

      // Find the superset item index in the day
      const circuitIndex = selectedDay.items.findIndex(
        (item) => item._id === circuitId,
      );
      if (circuitIndex === -1) return prevWeeks;

      // Copy the circuit item and its exercises
      const circuitItem = { ...selectedDay.items[circuitIndex] };
      const exercises = circuitItem.circuit?.exercises
        ? [...circuitItem.circuit.exercises]
        : [];

      // Find indexes of the dragged item and the item it is dropped over
      const activeIndex = exercises.findIndex(
        (ex) => String(ex._id) === String(active.id),
      );
      const overIndex = exercises.findIndex(
        (ex) => String(ex._id) === String(over.id),
      );

      if (activeIndex === -1 || overIndex === -1) return prevWeeks;

      // Reorder exercises array
      const [movedExercise] = exercises.splice(activeIndex, 1);
      exercises.splice(overIndex, 0, movedExercise);

      // Update circuit exercises immutably
      circuitItem.circuit = {
        ...circuitItem.circuit,
        exercises,
      };

      // Replace the superset item in the day items array
      const newItems = [...selectedDay.items];
      newItems[circuitIndex] = circuitItem;

      // Replace the day with updated items
      newDays[dayIdx] = {
        ...selectedDay,
        items: newItems,
      };

      // Replace the week days
      selectedWeek.days = newDays;
      newWeeks[weekIdx] = selectedWeek;

      return newWeeks;
    });
  };

  // Filter weeks by selected month (redundant here since backend filters, but keeps UI safe)
  const filteredWeeks = (weeks || []).filter(
    (week) =>
      typeof week.week_start_date === "string" &&
      week.week_start_date.startsWith(selectedMonth),
  );

  // rest of your component (UI rendering, handlers, etc.) unchanged...

  //video functions
  const [videoUrlToPlay, setVideoUrlToPlay] = useState(null);

  const getYouTubeVideoId = (url) => {
    const match = url.match(
      /(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([^&\n?#]+)/,
    );
    return match ? match[1] : null;
  };

  const getExerciseObject = (exerciseId, exerciseLibrary) => {
    if (!exerciseId) return null;
    const id = typeof exerciseId === "object" ? exerciseId._id : exerciseId;
    return exerciseLibrary.find((ex) => ex._id.toString() === id.toString());
  };

  const TIME_OPTIONS = [
    ...Array.from({ length: 6 }, (_, i) => `${(i + 1) * 10}s`), // 10s to 60s
    ...Array.from({ length: 5 }, (_, i) => `${i + 1} min`), // 1 min to 5 min
  ];

  const tempIdsRef = useRef({});

  //training focus section
  const [trainingFocuses, setTrainingFocuses] = useState([]);
  const [error, setError] = useState(null);
  const [trainingFocus, setTrainingFocus] = useState("");
  const [trainingPhase, setTrainingPhase] = useState("");
  const [items, setItems] = useState([]);

  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredTemplates = trainingFocuses.filter(
    (template) =>
      template.training_focus
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      template.training_phase.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const paginatedTemplates = filteredTemplates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);

  useEffect(() => {
    const fetchTrainingFocuses = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          API_URL.ADMIN_STRENGTH_TEMPLATE_TRAINING_FOCUS_MANAGE,
          {
            headers: { Authorization: `Bearer ${staff.token}` },
          },
        );
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setTrainingFocuses(result.data);
        } else {
          setTrainingFocuses([]);
          setError("Unexpected response format.");
        }
      } catch (err) {
        console.error("Failed to fetch training focuses:", err);
        setError("Unable to load training focuses");
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingFocuses();
  }, []);

  const [expandedRow, setExpandedRow] = useState(null);

  const toggleExpand = (id) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };

  const handleUseFocusTemplate = (template) => {
    if (!template || !selectedDayInfo) return;

    if (!exerciseLibrary || exerciseLibrary.length === 0) {
      alert("Exercise library is still loading. Please try again.");
      return;
    }

    const confirmCopy = window.confirm(
      `Are you sure you want to use the template "${template.training_focus}" for Week ${selectedDayInfo.weekIdx + 1} – Day ${selectedDayInfo.dayIdx + 1}? This will overwrite any existing exercises for that day.`,
    );

    if (!confirmCopy) return;

    const hydrateAndClone = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(hydrateAndClone);
      }

      if (obj && typeof obj === "object") {
        const newObj = {};

        for (const key in obj) {
          if (key === "_id") {
            newObj._id = generateUniqueId();
          } else if (key === "exercise_id" && obj[key]) {
            let match;

            if (obj[key]._id) {
              match = exerciseLibrary.find((ex) => ex._id === obj[key]._id);
            } else if (typeof obj[key] === "string") {
              match = exerciseLibrary.find((ex) => ex._id === obj[key]);
            }

            if (match) {
              newObj[key] = { ...match };
            } else {
              console.warn("⚠️ Could not hydrate exercise_id:", obj[key]);
              newObj[key] = { ...obj[key] }; // fallback
            }
          } else {
            newObj[key] = hydrateAndClone(obj[key]);
          }
        }

        return newObj;
      }

      return obj;
    };

    const hydratedTemplate = {
      ...template,
      items: hydrateAndClone(template.items || []),
    };

    setWeeks((prev) => {
      const updated = structuredClone(prev);
      const { weekIdx, dayIdx } = selectedDayInfo;

      if (updated[weekIdx]?.days?.[dayIdx]) {
        updated[weekIdx].days[dayIdx].items = hydratedTemplate.items;
        updated[weekIdx].days[dayIdx].training_focus =
          hydratedTemplate.training_focus; // optional
        updated[weekIdx].days[dayIdx].training_phase =
          hydratedTemplate.training_phase; // optional
      }

      return updated;
    });
  };

  //end of training focus section

  //1RM Logic
  const updateExerciseOneRM = (weekIdx, dayIdx, itemIdx, value) => {
    setWeeks((prev) => {
      const updated = structuredClone(prev);

      const item = updated?.[weekIdx]?.days?.[dayIdx]?.items?.[itemIdx];
      if (!item) return prev; // bail out safely

      // initialize exercise object if missing
      if (!item.exercise) {
        item.exercise = { sets: [], one_rm: 0 };
      }

      item.exercise.one_rm = Number(value) || 0;

      return updated;
    });
  };

  const updateSupersetExerciseField = (supersetId, sIdx, field, value) => {
    setWeeks((prev) => {
      const updated = [...prev];

      // find the superset in program
      updated.forEach((week) => {
        week.days.forEach((day) => {
          day.items.forEach((itm) => {
            if (itm._id === supersetId && itm.type === "superset") {
              if (itm.superset.exercises[sIdx]) {
                itm.superset.exercises[sIdx][field] = value;
              }
            }
          });
        });
      });

      return updated;
    });
  };

  const updateCircuitExerciseField = (circuitId, sIdx, field, value) => {
    setWeeks((prev) => {
      const updated = [...prev];

      // find the circuit in program
      updated.forEach((week) => {
        week.days.forEach((day) => {
          day.items.forEach((itm) => {
            if (itm._id === circuitId && itm.type === "circuit") {
              if (itm.circuit.exercises[sIdx]) {
                itm.circuit.exercises[sIdx][field] = value;
              }
            }
          });
        });
      });

      return updated;
    });
  };

  //end of 1RM Logic

  return (
    <div className="flex md:h-screen">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 bg-bgBase md:overflow-auto h-full max-md:pt-4">
        {/* Header */}
        <div className="flex flex-col shadow md:sticky md:top-0 z-30">
          {athlete && (
            <AthleteProfileCard athlete={athlete} onSaveSuccess={() => {}} />
          )}
          <div className="-mt-4">
            <AthleteTabMenu active="strength-workout" />
          </div>
        </div>

        <div className="py-10 px-5 md:px-8 xl:px-16 overflow-auto">
          <div className="w-full max-w-[1336px]">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:bg-white md:border md:border-tblBorder rounded-14 md:p-4 xl:p-6">
              {/* filter week */}
              <div className="lg:col-span-4 2xl:col-span-3">
                <div className="bg-white border border-tblBorder rounded-14 p-4 xl:p-6 space-y-4 md:space-y-6">
                  {/* Filter and Add Week */}
                  <div className="space-y-2 pb-5 border-b border-tblBorder mb-4">
                    <label className="block text-slate100 font-inter text-xs font-normal uppercase">
                      Filter by Month:
                    </label>
                    <input
                      type="month"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                    />
                  </div>

                  <button
                    onClick={() => setShowDatePicker(true)}
                    className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black capitalize flex items-center justify-center gap-2"
                  >
                    <MdAdd color="#fff" size={18} /> add week
                  </button>
                  {/* Week Date Picker */}
                  {showDatePicker && (
                    <div
                      className="mb-4 space-y-4 cursor-pointer"
                      onClick={(e) => {
                        // Only trigger if clicking the container itself, not child inputs/buttons
                        if (e.target === e.currentTarget) {
                          document
                            .getElementById("week-date-input")
                            ?.showPicker?.();
                        }
                      }}
                    >
                      <div className="space-y-1 admindate">
                        <label
                          className="block text-slate100 font-inter text-xs font-normal uppercase"
                          onClick={() =>
                            document
                              .getElementById("week-date-input")
                              ?.showPicker?.()
                          }
                        >
                          Select Start Date of New Week (must be Sunday):
                        </label>

                        <input
                          id="week-date-input"
                          type="date"
                          value={newWeekStartDate}
                          onChange={(e) => setNewWeekStartDate(e.target.value)}
                          className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.target.showPicker?.();
                          }}
                        />
                      </div>
                      <div className="flex gap-3">
                        <button
                          onClick={handleSaveNewWeek}
                          className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black capitalize"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCloseNewWeek}
                          className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black capitalize flex items-center justify-center gap-2"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* data part */}
              <div className="lg:col-span-8 2xl:col-span-9">
                <div className="bg-white border border-tblBorder rounded-14 font-inter">
                  <div className="p-4 xl:p-6">
                    {/* Success Message */}
                    {successMessage && (
                      <div className="mb-3 p-2 text-sm text-green-800 bg-green-100 border border-green-300 rounded">
                        {successMessage}
                      </div>
                    )}

                    {/* Week Tabs */}
                    {filteredWeeks.length > 0 && (
                      <div className="mb-4">
                        <div className="flex flex-wrap gap-2 mb-3">
                          {filteredWeeks.map((week, idx) => (
                            <div
                              key={week._id}
                              className="flex items-center gap-3"
                            >
                              <button
                                onClick={() => setActiveWeekTab(idx)}
                                className={`px-3 py-1 font-inter text-sm rounded-t border-b-2  ${
                                  activeWeekTab === idx
                                    ? "border-darkYellow text-darkYellow font-semibold"
                                    : "border-transparent text-slate100 hover:text-darkYellow"
                                }`}
                              >
                                {`Week of ${getFormattedDate(week.week_start_date)}`}
                              </button>
                              <button
                                onClick={() => handleDeleteWeek(week._id)}
                                title="Delete Week"
                                className="p-2 hover:bg-gray-200 rounded"
                                type="button"
                              >
                                <RiDeleteBin4Line color="#666666" size={18} />
                              </button>
                            </div>
                          ))}
                        </div>

                        {/* Days in selected week */}
                        <div className="flex gap-2 overflow-auto show-scrollbar">
                          {filteredWeeks[activeWeekTab]?.days?.map(
                            (day, dayIdx) => (
                              <button
                                key={dayIdx}
                                onClick={() =>
                                  setSelectedDayInfo({
                                    weekIdx: activeWeekTab,
                                    dayIdx,
                                  })
                                }
                                className={`px-2 py-1 rounded shadow-sm font-inter font-medium text-xs text-center border ${
                                  selectedDayInfo?.weekIdx === activeWeekTab &&
                                  selectedDayInfo?.dayIdx === dayIdx
                                    ? "bg-dark text-white"
                                    : "bg-white text-gray-700 hover:bg-gray-100"
                                } flex flex-col items-start`}
                              >
                                {day.label}
                                <br />
                                <span className="text-[12px]">
                                  {(() => {
                                    const [year, month, dayNum] = day.date
                                      .split("-")
                                      .map(Number);
                                    const date = new Date(
                                      year,
                                      month - 1,
                                      dayNum,
                                    );
                                    return date.toLocaleDateString("en-US", {
                                      year: "numeric",
                                      month: "numeric",
                                      day: "numeric",
                                    });
                                  })()}
                                </span>
                              </button>
                            ),
                          )}
                        </div>
                      </div>
                    )}

                    {/* Builder placeholder */}
                    {selectedDayInfo && (
                      <div className="mt-6 font-inter">
                        <div>
                          <span className="font-medium">
                            {(() => {
                              const dateStr =
                                filteredWeeks[selectedDayInfo.weekIdx].days[
                                  selectedDayInfo.dayIdx
                                ].date;
                              const [year, month, day] = dateStr
                                .split("-")
                                .map(Number);
                              const date = new Date(year, month - 1, day);
                              return date.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                              });
                            })()}
                          </span>
                          {filteredWeeks[selectedDayInfo.weekIdx]?.days?.[
                            selectedDayInfo.dayIdx
                          ]?.training_focus && (
                            <span className="block text-darkYellow font-medium">
                              {
                                filteredWeeks[selectedDayInfo.weekIdx]?.days?.[
                                  selectedDayInfo.dayIdx
                                ]?.training_focus
                              }
                            </span>
                          )}
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-wrap md:justify-end gap-2 py-6 border-b border-tblBorder mb-6">
                          <button
                            onClick={() => setShowAddExerciseForm(true)}
                            className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-medium text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                          >
                            <MdAdd color="#000" size={18} /> Exercise
                          </button>
                          <button
                            onClick={() => setShowAddSupersetForm(true)}
                            className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-medium text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                          >
                            <MdAdd color="#000" size={18} /> Superset
                          </button>

                          <button
                            onClick={() => setShowAddCircuitForm(true)}
                            className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-medium text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                          >
                            <MdAdd color="#000" size={18} /> Circuit
                          </button>

                          <button
                            onClick={() => setReorderMode(!reorderMode)}
                            className={`pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-medium text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200`}
                          >
                            <DotedSvg />{" "}
                            {reorderMode ? "Back to Editor" : "Reorder"}
                          </button>

                          <button
                            disabled={savingAll}
                            onClick={handleSaveAllWeeks}
                            title="Save all weeks to backend"
                            className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black inline-flex items-center gap-2"
                          >
                            <SaveTempIcon /> Save Template
                          </button>
                        </div>

                        {reorderMode ? (
                          <div className="">
                            <div className="flex items-center gap-3">
                              <div
                                className="p-2 rounded-lg border border-tblBorder bg-white flex items-center
                                                 gap-1 text-dark text-xs font-medium flex-none"
                              >
                                <DotedSvg /> Reorder Mode
                              </div>
                              <span className="flex-1 bg-tblBorder h-px w-full"></span>
                            </div>
                            <div className="space-y-0.5 mt-3">
                              <DndContext
                                onDragEnd={(event) =>
                                  handleItemDragEnd(
                                    event,
                                    selectedDayInfo.weekIdx,
                                    selectedDayInfo.dayIdx,
                                  )
                                }
                              >
                                {weeks?.[selectedDayInfo.weekIdx]?.days?.[
                                  selectedDayInfo.dayIdx
                                ]?.items?.map((item, idx) => {
                                  const getItemDisplayName = (item) => {
                                    if (!item) return "Unknown";

                                    switch (item.type) {
                                      case "exercise":
                                        // If exercise_id is an object, get .title, else try to find in library
                                        if (
                                          typeof item.exercise?.exercise_id ===
                                          "object"
                                        ) {
                                          return (
                                            item.exercise.exercise_id?.title ||
                                            "Unnamed Exercise"
                                          );
                                        }
                                        return (
                                          exerciseLibrary.find(
                                            (ex) =>
                                              ex._id ===
                                              item.exercise?.exercise_id,
                                          )?.title || "Unnamed Exercise"
                                        );

                                      case "superset":
                                        return (
                                          item.superset?.title ||
                                          `Superset (${item.superset?.exercises
                                            ?.map((ex) =>
                                              typeof ex.exercise_id === "object"
                                                ? ex.exercise_id?.title
                                                : exerciseLibrary.find(
                                                    (libEx) =>
                                                      libEx._id ===
                                                      ex.exercise_id,
                                                  )?.title || "Unnamed",
                                            )
                                            .join(" + ")})`
                                        );

                                      case "circuit":
                                        return (
                                          item.circuit?.title ||
                                          `Circuit (${item.circuit?.exercises
                                            ?.map((ex) =>
                                              typeof ex.exercise_id === "object"
                                                ? ex.exercise_id?.title
                                                : exerciseLibrary.find(
                                                    (libEx) =>
                                                      libEx._id ===
                                                      ex.exercise_id,
                                                  )?.title || "Unnamed",
                                            )
                                            .join(" + ")})`
                                        );

                                      default:
                                        return "Item";
                                    }
                                  };

                                  // const itemId = item._id || `item-${idx}`; // fallback if no _id
                                  let itemId = item._id;

                                  // If no _id, assign or reuse a tempId for this item index
                                  if (!itemId) {
                                    if (!tempIdsRef.current[idx]) {
                                      tempIdsRef.current[idx] =
                                        `temp-${Date.now()}-${idx}`; // generate unique tempId
                                    }
                                    itemId = tempIdsRef.current[idx];
                                  }

                                  return (
                                    <DroppableEX key={itemId} id={itemId}>
                                      <DraggableEXItem
                                        key={itemId}
                                        id={itemId}
                                        itemIndex={idx}
                                        item={item}
                                        displayName={getItemDisplayName(item)} // Pass the name prop here
                                      />
                                    </DroppableEX>
                                  );
                                })}
                              </DndContext>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* Add Exercise Form */}
                            {showAddExerciseForm && (
                              <div className="bg-bgBase border border-tblBorder rounded-14 p-4 mb-4">
                                <label className="block text-sm font-medium mb-2">
                                  Select Exercise
                                </label>
                                <div className="flex max-xl:flex-wrap gap-3">
                                  <SingleSelectExerciseList
                                    exercises={exerciseLibrary}
                                    value={selectedExerciseId}
                                    onChange={(val) =>
                                      setSelectedExerciseId(val)
                                    }
                                  />

                                  <div className="flex items-end gap-3">
                                    <button
                                      onClick={handleAddExercise}
                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex items-center gap-2"
                                    >
                                      <MdAdd color="#fff" size={18} /> Exercise
                                    </button>

                                    <button
                                      onClick={() =>
                                        setShowAddExerciseForm(false)
                                      }
                                      className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Superset form add title */}
                            {showAddSupersetForm && (
                              <div className="bg-bgBase border border-tblBorder rounded-14 p-4 mb-4">
                                <label className="block text-sm font-medium mb-2">
                                  Superset Title
                                </label>

                                <div className="flex max-xl:flex-wrap gap-3">
                                  <input
                                    type="text"
                                    value={newSupersetTitle}
                                    onChange={(e) =>
                                      setNewSupersetTitle(e.target.value)
                                    }
                                    placeholder="Enter Superset Title"
                                    className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                                  />

                                  <div className="flex gap-2">
                                    <button
                                      onClick={handleAddSuperset}
                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex items-center gap-2"
                                    >
                                      <MdAdd color="#fff" size={18} /> Superset
                                    </button>
                                    <button
                                      onClick={() => {
                                        setShowAddSupersetForm(false);
                                        setNewSupersetTitle("");
                                      }}
                                      className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Circuit form add title */}
                            {showAddCircuitForm && (
                              <div className="bg-bgBase border border-tblBorder rounded-14 p-4 mb-4">
                                <label className="block text-sm font-medium mb-2">
                                  Circuit Title
                                </label>
                                <div className="flex max-xl:flex-wrap gap-3">
                                  <input
                                    type="text"
                                    value={newCircuitTitle}
                                    onChange={(e) =>
                                      setNewCircuitTitle(e.target.value)
                                    }
                                    placeholder="Enter Circuit Title"
                                    className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                                  />

                                  <div className="flex gap-2">
                                    <button
                                      onClick={handleAddCircuit}
                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex items-center gap-2"
                                    >
                                      <MdAdd color="#fff" size={18} /> Circuit
                                    </button>
                                    <button
                                      onClick={() => {
                                        setShowAddCircuitForm(false);
                                        setNewCircuitTitle("");
                                      }}
                                      className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="space-y-3">
                              {filteredWeeks[selectedDayInfo.weekIdx].days[
                                selectedDayInfo.dayIdx
                              ].items.map((item, idx) => {
                                const isExercise = item.type === "exercise";
                                const exerciseObj = isExercise
                                  ? getExerciseObject(
                                      item.exercise?.exercise_id,
                                      exerciseLibrary,
                                    )
                                  : null;

                                return (
                                  <div
                                    key={idx}
                                    className={`${isExercise && "border border-tblBorder bg-white rounded-10 overflow-hidden group"}`}
                                  >
                                    <div>
                                      {/* name */}
                                      {isExercise && (
                                        <div className="px-4 py-3 bg-tblHead rounded-t-10 font-medium flex max-md:flex-col md:items-center gap-4">
                                          {(exerciseObj?.video_url || true) && (
                                            <>
                                              {/* Video Preview / title */}
                                              <div className="flex-none size-16">
                                                {exerciseObj?.video_url && (
                                                  <div className="relative h-full">
                                                    {" "}
                                                    <img
                                                      src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                      alt="Video thumbnail"
                                                      className="w-full h-full rounded-lg border object-cover"
                                                    />{" "}
                                                    <button
                                                      className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2] text-white text-sm underline"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        setVideoUrlToPlay(
                                                          exerciseObj.video_url,
                                                        );
                                                      }}
                                                    >
                                                      {" "}
                                                      ▶{" "}
                                                    </button>{" "}
                                                  </div>
                                                )}
                                              </div>
                                              <div className="w-full flex max-md:flex-col gap-4">
                                                {/* exerciseObj?.title */}
                                                <div className="max-md:w-full max-xl:flex-1 xl:w-[60%]  flex flex-col gap-1.5">
                                                  <span className="text-slate100 text-xs font-medium">
                                                    Exercise:
                                                  </span>
                                                  <p className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none">
                                                    {exerciseObj?.title}
                                                  </p>
                                                </div>
                                                {/* 1RM Input */}
                                                <div className="max-md:w-full max-xl:flex-1 xl:w-[40%] flex flex-col gap-1.5">
                                                  <label className="text-slate100 text-xs font-medium">
                                                    1RM (lbs):
                                                  </label>
                                                  <input
                                                    type="number"
                                                    placeholder="Enter 1RM"
                                                    value={
                                                      item.exercise?.one_rm ??
                                                      ""
                                                    }
                                                    className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none"
                                                    onChange={(e) =>
                                                      updateExerciseOneRM(
                                                        selectedDayInfo.weekIdx,
                                                        selectedDayInfo.dayIdx,
                                                        idx,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>

                                              <div className="flex items-center gap-2">
                                                {true && (
                                                  <button
                                                    className="flex-none rounded hover:bg-white p-2"
                                                    title="Delete Exercise"
                                                    onClick={() => {
                                                      if (
                                                        window.confirm(
                                                          "Delete this workout?",
                                                        )
                                                      ) {
                                                        handleDeleteExercise(
                                                          selectedDayInfo.weekIdx,
                                                          selectedDayInfo.dayIdx,
                                                          idx,
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <RiDeleteBin4Line
                                                      color="#666666"
                                                      size={18}
                                                    />
                                                  </button>
                                                )}

                                                <button
                                                  onClick={() =>
                                                    setOpenIndexes((prev) =>
                                                      prev.includes(idx)
                                                        ? prev.filter(
                                                            (i) => i !== idx,
                                                          )
                                                        : [...prev, idx],
                                                    )
                                                  }
                                                  className="rounded hover:bg-gray-200 p-2"
                                                >
                                                  <IoIosArrowDown
                                                    color="#666666"
                                                    size={18}
                                                    className={`${openIndexes.includes(idx) ? "rotate-180" : "rotate-0"}`}
                                                  />
                                                </button>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      )}

                                      {/* superset and circuit heading */}
                                      {!isExercise && (
                                        <div className="w-full flex items-center gap-2 md:gap-4 mb-4">
                                          <div className="md:flex-none max-md:text-start md:py-2.5 text-slate100 text-[10px] sm:text-xs font-medium uppercase hover:text-black hover:underline">
                                            {item.type === "superset" &&
                                              (item.superset?.title ||
                                                "Untitled Superset")}{" "}
                                            {item.type === "circuit" &&
                                              (item.circuit?.title ||
                                                "Untitled Circuit")}
                                            {/* {isExercise &&
                                                (exerciseObj?.title ||
                                                  "Unnamed Exercise")}{" "}
                                              {item.type === "superset" &&
                                                (item.superset?.title ||
                                                  "Untitled Superset")}{" "}
                                              {item.type === "circuit" &&
                                                (item.circuit?.title ||
                                                  "Untitled Circuit")} */}
                                          </div>
                                          <>
                                            {/* arrow */}
                                            <button
                                              onClick={() =>
                                                setOpenIndexes((prev) =>
                                                  prev.includes(idx)
                                                    ? prev.filter(
                                                        (i) => i !== idx,
                                                      )
                                                    : [...prev, idx],
                                                )
                                              }
                                              className="rounded hover:bg-gray-200 p-2"
                                            >
                                              <IoIosArrowDown
                                                color="#666666"
                                                size={18}
                                                className={`${openIndexes.includes(idx) ? "rotate-180" : "rotate-0"}`}
                                              />
                                            </button>
                                            {/* reorder btn */}
                                            {openIndexes.includes(idx) && (
                                              <>
                                                {item.type === "superset" ||
                                                item.type === "circuit" ? (
                                                  <>
                                                    <button
                                                      onClick={() =>
                                                        item.type === "superset"
                                                          ? setSSReorderMode(
                                                              (prev) =>
                                                                prev ===
                                                                item._id
                                                                  ? null
                                                                  : item._id,
                                                            )
                                                          : setCCReorderMode(
                                                              (prev) => !prev,
                                                            )
                                                      }
                                                      className="flex-none px-2 py-1.5 max-sm:w-fit bg-white text-dark border border-tblBorder font-inter font-normal text-[10px] md:text-xs leading-tight rounded-lg flex items-center gap-1 md:gap-1.5 hover:bg-gray-200"
                                                    >
                                                      <DotedSvg />{" "}
                                                      {item.type === "superset"
                                                        ? ssreorderMode ===
                                                          item._id
                                                          ? "Done Reordering"
                                                          : "Reorder Superset"
                                                        : ccreorderMode
                                                          ? "Done Reordering"
                                                          : "Reorder Circuit"}
                                                    </button>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            )}

                                            <div className="w-full hidden md:flex">
                                              <span className="bg-tblBorder w-full h-px"></span>
                                            </div>
                                          </>
                                        </div>
                                      )}
                                    </div>

                                    {openIndexes.includes(idx) && (
                                      <>
                                        {isExercise && (
                                          <>
                                            {/* --- SETS UI BLOCK START --- */}
                                            <div className="p-4 space-y-6 bg-white border-t border-tblBorder">
                                              {item.exercise.sets.map(
                                                (set, setIdx) => {
                                                  const oneRM =
                                                    item.exercise?.one_rm || 0;
                                                  const computedWeight =
                                                    set.unit === "%" && oneRM
                                                      ? Math.ceil(
                                                          (((set.weight || 0) /
                                                            100) *
                                                            oneRM) /
                                                            5,
                                                        ) * 5
                                                      : set.unit === "lbs"
                                                        ? set.weight || ""
                                                        : "";

                                                  return (
                                                    <>
                                                      {" "}
                                                      <div
                                                        key={setIdx}
                                                        className="flex flex-col gap-3"
                                                      >
                                                        {" "}
                                                        <div className="flex items-start gap-3 bg-tblHead border border-tblBorder rounded-10 p-4 ">
                                                          {" "}
                                                          <div className="flex flex-wrap gap-3 items-center text-sm">
                                                            {" "}
                                                            {/* Reps */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <input
                                                                type="number"
                                                                placeholder="Reps"
                                                                value={
                                                                  set.reps || ""
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                onChange={(e) =>
                                                                  updateSet(
                                                                    selectedDayInfo.weekIdx,
                                                                    selectedDayInfo.dayIdx,
                                                                    idx,
                                                                    setIdx,
                                                                    "reps",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                              />{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Reps{" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Weight */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <input
                                                                type="number"
                                                                placeholder="Weight"
                                                                value={
                                                                  set.weight ||
                                                                  ""
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                onChange={(e) =>
                                                                  updateSet(
                                                                    selectedDayInfo.weekIdx,
                                                                    selectedDayInfo.dayIdx,
                                                                    idx,
                                                                    setIdx,
                                                                    "weight",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                              />{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Weight{" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Unit */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <select
                                                                value={
                                                                  set.unit ||
                                                                  "%"
                                                                }
                                                                onChange={(e) =>
                                                                  updateSet(
                                                                    selectedDayInfo.weekIdx,
                                                                    selectedDayInfo.dayIdx,
                                                                    idx,
                                                                    setIdx,
                                                                    "unit",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                              >
                                                                {" "}
                                                                <option value="%">
                                                                  {" "}
                                                                  %{" "}
                                                                </option>{" "}
                                                                <option value="lbs">
                                                                  {" "}
                                                                  lbs{" "}
                                                                </option>{" "}
                                                                <option value="hide">
                                                                  {" "}
                                                                  Hide{" "}
                                                                </option>{" "}
                                                                <option value="time">
                                                                  {" "}
                                                                  Time{" "}
                                                                </option>{" "}
                                                              </select>{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Unit{" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Time – only visible if unit === "time" */}{" "}
                                                            {set.unit ===
                                                              "time" && (
                                                              <div className="flex-1 min-w-28">
                                                                {" "}
                                                                <select
                                                                  value={
                                                                    set.time ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSet(
                                                                      selectedDayInfo.weekIdx,
                                                                      selectedDayInfo.dayIdx,
                                                                      idx,
                                                                      setIdx,
                                                                      "time",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                >
                                                                  {" "}
                                                                  <option value="">
                                                                    {" "}
                                                                    Select
                                                                    time{" "}
                                                                  </option>{" "}
                                                                  {TIME_OPTIONS.map(
                                                                    (label) => (
                                                                      <option
                                                                        key={
                                                                          label
                                                                        }
                                                                        value={
                                                                          label
                                                                        }
                                                                      >
                                                                        {" "}
                                                                        {
                                                                          label
                                                                        }{" "}
                                                                      </option>
                                                                    ),
                                                                  )}{" "}
                                                                </select>{" "}
                                                                <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                  {" "}
                                                                  Time{" "}
                                                                </label>{" "}
                                                              </div>
                                                            )}{" "}
                                                            {/* Computed lbs */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <input
                                                                type="text"
                                                                value={
                                                                  computedWeight
                                                                    ? Math.round(
                                                                        computedWeight,
                                                                      )
                                                                    : ""
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                readOnly
                                                              />{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Computed Weight
                                                                (lbs){" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Goal */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <select
                                                                value={
                                                                  set.goal || ""
                                                                }
                                                                onChange={(e) =>
                                                                  updateSet(
                                                                    selectedDayInfo.weekIdx,
                                                                    selectedDayInfo.dayIdx,
                                                                    idx,
                                                                    setIdx,
                                                                    "goal",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                              >
                                                                {" "}
                                                                <option value="">
                                                                  {" "}
                                                                  &mdash; Goal
                                                                  &mdash;{" "}
                                                                </option>{" "}
                                                                <option value="< 0.5 m/s (Absolute Strength)">
                                                                  {" "}
                                                                  &lt; 0.5 m/s
                                                                  (Absolute
                                                                  Strength){" "}
                                                                </option>{" "}
                                                                <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                  {" "}
                                                                  0.5 - 0.75 m/s
                                                                  (Accelerative
                                                                  Strength){" "}
                                                                </option>{" "}
                                                                <option value="0.75 - 1 m/s (Strength Speed)">
                                                                  {" "}
                                                                  0.75 - 1 m/s
                                                                  (Strength
                                                                  Speed){" "}
                                                                </option>{" "}
                                                                <option value="1 - 1.3 m/s (Speed Strength)">
                                                                  {" "}
                                                                  1 - 1.3 m/s
                                                                  (Speed
                                                                  Strength){" "}
                                                                </option>{" "}
                                                                <option value="> 1.3 m/s (Starting Strength)">
                                                                  {" "}
                                                                  &gt; 1.3 m/s
                                                                  (Starting
                                                                  Strength){" "}
                                                                </option>{" "}
                                                                <option value="> 2 m/s (Speed)">
                                                                  {" "}
                                                                  &gt; 2 m/s
                                                                  (Speed){" "}
                                                                </option>{" "}
                                                              </select>{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Goal{" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Rest */}{" "}
                                                            <div className="flex-1 min-w-28">
                                                              {" "}
                                                              <input
                                                                type="text"
                                                                placeholder="Rest"
                                                                value={
                                                                  set.rest || ""
                                                                }
                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                onChange={(e) =>
                                                                  updateSet(
                                                                    selectedDayInfo.weekIdx,
                                                                    selectedDayInfo.dayIdx,
                                                                    idx,
                                                                    setIdx,
                                                                    "rest",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                              />{" "}
                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                {" "}
                                                                Rest{" "}
                                                              </label>{" "}
                                                            </div>{" "}
                                                            {/* Notes */}{" "}
                                                          </div>{" "}
                                                          {/* Delete */}{" "}
                                                          <div>
                                                            {" "}
                                                            <button
                                                              onClick={() =>
                                                                deleteSet(
                                                                  selectedDayInfo.weekIdx,
                                                                  selectedDayInfo.dayIdx,
                                                                  idx,
                                                                  setIdx,
                                                                )
                                                              }
                                                              title="Delete set"
                                                              type="button"
                                                              className="rounded hover:bg-white p-2"
                                                            >
                                                              {" "}
                                                              <RiDeleteBin4Line
                                                                color="#666666"
                                                                size={18}
                                                              />{" "}
                                                            </button>{" "}
                                                          </div>{" "}
                                                        </div>{" "}
                                                        <div className="flex flex-col gap-2 pb-5 border-b border-tblBorder mb-0">
                                                          {" "}
                                                          <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                            {" "}
                                                            Notes{" "}
                                                          </label>{" "}
                                                          <textarea
                                                            placeholder="Notes"
                                                            value={
                                                              set.notes || ""
                                                            }
                                                            className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none"
                                                            onChange={(e) =>
                                                              updateSet(
                                                                selectedDayInfo.weekIdx,
                                                                selectedDayInfo.dayIdx,
                                                                idx,
                                                                setIdx,
                                                                "notes",
                                                                e.target.value,
                                                              )
                                                            }
                                                          />{" "}
                                                        </div>{" "}
                                                      </div>{" "}
                                                    </>
                                                  );
                                                },
                                              )}
                                              <button
                                                onClick={() =>
                                                  addSet(
                                                    selectedDayInfo.weekIdx,
                                                    selectedDayInfo.dayIdx,
                                                    idx,
                                                  )
                                                }
                                                className="text-xs font-medium text-slate100 hover:text-dark group flex items-center gap-1"
                                                type="button"
                                              >
                                                {" "}
                                                <MdAdd
                                                  color="#666666"
                                                  size={18}
                                                  className="group-hover:!text-black"
                                                />{" "}
                                                Add Set{" "}
                                              </button>
                                            </div>
                                            {/* --- SETS UI BLOCK END --- */}
                                          </>
                                        )}

                                        {item.type === "superset" && (
                                          <div className="space-y-2">
                                            {/* Reorder Mode */}
                                            {ssreorderMode === item._id ? (
                                              <div className="">
                                                <div className="flex items-center gap-3">
                                                  {" "}
                                                  <div className="p-2 rounded-lg border border-tblBorder bg-white flex items-center gap-1 text-dark text-xs font-medium flex-none">
                                                    {" "}
                                                    <DotedSvg /> Reorder
                                                    Mode{" "}
                                                  </div>{" "}
                                                  <span className="flex-1 bg-tblBorder h-px w-full"></span>{" "}
                                                </div>
                                                <div className="space-y-0.5 mt-3">
                                                  {" "}
                                                  <DndContext
                                                    onDragEnd={(e) =>
                                                      handleSupersetReorderEnd(
                                                        e,
                                                        selectedDayInfo.weekIdx,
                                                        selectedDayInfo.dayIdx,
                                                        item._id,
                                                      )
                                                    }
                                                  >
                                                    {" "}
                                                    {item.superset?.exercises?.map(
                                                      (sup, sIdx) => (
                                                        <DroppableSSEX
                                                          key={sup._id}
                                                          id={String(sup._id)}
                                                        >
                                                          {" "}
                                                          <DraggableSSEXItem
                                                            id={String(sup._id)}
                                                            itemIndex={sIdx}
                                                            item={sup}
                                                            displayName={
                                                              typeof sup.exercise_id ===
                                                              "object"
                                                                ? sup
                                                                    .exercise_id
                                                                    ?.title ||
                                                                  "Unnamed Exercise"
                                                                : exerciseLibrary.find(
                                                                    (ex) =>
                                                                      ex._id ===
                                                                      sup.exercise_id,
                                                                  )?.title ||
                                                                  "Unnamed Exercise"
                                                            }
                                                            style={{
                                                              padding: 0,
                                                            }}
                                                          />{" "}
                                                        </DroppableSSEX>
                                                      ),
                                                    )}{" "}
                                                  </DndContext>{" "}
                                                </div>{" "}
                                              </div>
                                            ) : (
                                              /* Normal Render Mode */
                                              item.superset?.exercises?.map(
                                                (sup, sIdx) => {
                                                  const isOpen =
                                                    openSupersetExercise.itemId ===
                                                      item._id &&
                                                    openSupersetExercise.sIdx ===
                                                      sIdx;
                                                  const exerciseObj =
                                                    getExerciseObject(
                                                      sup.exercise_id,
                                                      exerciseLibrary,
                                                    );

                                                  return (
                                                    <div
                                                      key={
                                                        sup._id || sup.tempId
                                                      } // <-- Use _id or tempId here!
                                                      className="bg-tblHead border border-tblBorder rounded-10"
                                                    >
                                                      {/* Header */}
                                                      <div className="flex-1 flex max-md:flex-col md:items-center gap-4 py-3 px-4">
                                                        <div className="max-md:W-full md:flex-1 flex md:items-center gap-4">
                                                          {/* video */}
                                                          <div className="flex-none size-16">
                                                            {" "}
                                                            {exerciseObj?.video_url && (
                                                              <div className="relative h-full">
                                                                {" "}
                                                                <img
                                                                  src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                                  alt="Video thumbnail"
                                                                  className="w-full h-full rounded-lg border object-cover"
                                                                />{" "}
                                                                <button
                                                                  className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2] text-white text-sm underline"
                                                                  onClick={(
                                                                    e,
                                                                  ) => {
                                                                    e.preventDefault();
                                                                    setVideoUrlToPlay(
                                                                      exerciseObj.video_url,
                                                                    );
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  ▶{" "}
                                                                </button>{" "}
                                                              </div>
                                                            )}{" "}
                                                          </div>
                                                          <div className="w-full flex max-md:flex-col gap-4">
                                                            {/* Exercise */}
                                                            <div className="max-xl:flex-1 xl:w-[60%] flex flex-col gap-1.5">
                                                              <label className="text-slate100 text-xs font-medium">
                                                                Exercise
                                                              </label>
                                                              <p
                                                                className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter
                                                               font-normal text-sm outline-none"
                                                              >
                                                                {exerciseObj?.title ||
                                                                  `Exercise ${sIdx + 1}`}{" "}
                                                              </p>{" "}
                                                            </div>
                                                            {/* 1RM Input (inline with preview) */}
                                                            <div className="max-xl:flex-1 xl:w-[40%] flex flex-col gap-1.5">
                                                              {" "}
                                                              <label className="text-slate100 text-xs font-medium">
                                                                {" "}
                                                                1RM:{" "}
                                                              </label>{" "}
                                                              <input
                                                                type="number"
                                                                className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none"
                                                                value={
                                                                  sup.one_rm ||
                                                                  ""
                                                                }
                                                                onChange={(e) =>
                                                                  updateSupersetExerciseField(
                                                                    item._id,
                                                                    sIdx,
                                                                    "one_rm",
                                                                    e.target
                                                                      .value,
                                                                  )
                                                                }
                                                                placeholder="lbs"
                                                              />{" "}
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="flex max-md:ml-auto md:items-center gap-2">
                                                          <button
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleDeleteSupersetExercise(
                                                                item._id,
                                                                sup._id ||
                                                                  sup.tempId,
                                                              );
                                                            }}
                                                            className="rounded hover:bg-white p-2"
                                                          >
                                                            <RiDeleteBin4Line
                                                              color="#666666"
                                                              size={18}
                                                            />
                                                          </button>
                                                          <button
                                                            onClick={() =>
                                                              setOpenSupersetExercise(
                                                                isOpen
                                                                  ? {
                                                                      itemId:
                                                                        null,
                                                                      sIdx: null,
                                                                    }
                                                                  : {
                                                                      itemId:
                                                                        item._id,
                                                                      sIdx,
                                                                    },
                                                              )
                                                            }
                                                            className="rounded hover:bg-gray-200 p-2"
                                                          >
                                                            <IoIosArrowDown
                                                              color="#666666"
                                                              size={18}
                                                              className={`${isOpen ? "rotate-180" : ""} transition-all`}
                                                            />
                                                          </button>
                                                        </div>
                                                      </div>

                                                      {/* Collapsible Content */}
                                                      {isOpen && (
                                                        <div className="px-3 py-2 text-sm bg-white rounded-b-10 border-t">
                                                          <div className="mt-2 space-y-3">
                                                            {(
                                                              sup.sets || []
                                                            ).map(
                                                              (set, setIdx) => {
                                                                let computedWeight =
                                                                  "";

                                                                // console.log("DEBUG -> set.unit:", JSON.stringify(set.unit), "sup.one_rm:", sup.one_rm);
                                                                if (
                                                                  set.unit ===
                                                                    "%" &&
                                                                  sup.one_rm
                                                                ) {
                                                                  const rawWeight =
                                                                    ((sup.one_rm ||
                                                                      0) *
                                                                      (set.weight ||
                                                                        0)) /
                                                                    100;
                                                                  // console.log("💡 % logic hit:", { rawWeight, one_rm: sup.one_rm, setWeight: set.weight });
                                                                  computedWeight =
                                                                    Math.ceil(
                                                                      rawWeight /
                                                                        5,
                                                                    ) * 5;
                                                                } else if (
                                                                  set.unit ===
                                                                  "lbs"
                                                                ) {
                                                                  computedWeight =
                                                                    set.weight ||
                                                                    "";
                                                                }

                                                                return (
                                                                  <>
                                                                    <div
                                                                      key={
                                                                        setIdx
                                                                      }
                                                                      className="flex flex-col gap-3"
                                                                    >
                                                                      <div className="flex items-start gap-3 bg-tblHead border border-tblBorder rounded-10 p-4 ">
                                                                        <div className="flex flex-wrap gap-3 items-center text-sm">
                                                                          {/* Reps */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Reps{" "}
                                                                            </label>{" "}
                                                                            <input
                                                                              type="number"
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none "
                                                                              value={
                                                                                set.reps ||
                                                                                ""
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                updateSupersetSet(
                                                                                  item._id,
                                                                                  sIdx,
                                                                                  setIdx,
                                                                                  "reps",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                              placeholder="Reps"
                                                                            />{" "}
                                                                          </div>

                                                                          {/* Weight */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Weight{" "}
                                                                            </label>{" "}
                                                                            <input
                                                                              type="number"
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                              value={
                                                                                set.weight ||
                                                                                ""
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                updateSupersetSet(
                                                                                  item._id,
                                                                                  sIdx,
                                                                                  setIdx,
                                                                                  "weight",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                              placeholder="Weight"
                                                                            />{" "}
                                                                          </div>
                                                                          {/* Unit */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Unit{" "}
                                                                            </label>{" "}
                                                                            <select
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                              value={
                                                                                set.unit ||
                                                                                ""
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                updateSupersetSet(
                                                                                  item._id,
                                                                                  sIdx,
                                                                                  setIdx,
                                                                                  "unit",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                            >
                                                                              {" "}
                                                                              <option value="%">
                                                                                {" "}
                                                                                %{" "}
                                                                              </option>{" "}
                                                                              <option value="lbs">
                                                                                {" "}
                                                                                lbs{" "}
                                                                              </option>{" "}
                                                                              <option value="hide">
                                                                                {" "}
                                                                                hide{" "}
                                                                              </option>{" "}
                                                                              <option value="time">
                                                                                {" "}
                                                                                Time{" "}
                                                                              </option>{" "}
                                                                            </select>{" "}
                                                                          </div>

                                                                          {/* Time */}
                                                                          {set.unit ===
                                                                            "time" && (
                                                                            <div className="flex-1 min-w-28">
                                                                              {" "}
                                                                              <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                                {" "}
                                                                                Time{" "}
                                                                              </label>{" "}
                                                                              <select
                                                                                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                                value={
                                                                                  set.time ||
                                                                                  ""
                                                                                }
                                                                                onChange={(
                                                                                  e,
                                                                                ) =>
                                                                                  updateSupersetSet(
                                                                                    item._id,
                                                                                    sIdx,
                                                                                    setIdx,
                                                                                    "time",
                                                                                    e
                                                                                      .target
                                                                                      .value,
                                                                                  )
                                                                                }
                                                                              >
                                                                                {" "}
                                                                                <option value="">
                                                                                  {" "}
                                                                                  Select{" "}
                                                                                </option>{" "}
                                                                                {TIME_OPTIONS.map(
                                                                                  (
                                                                                    label,
                                                                                  ) => (
                                                                                    <option
                                                                                      key={
                                                                                        label
                                                                                      }
                                                                                      value={
                                                                                        label
                                                                                      }
                                                                                    >
                                                                                      {" "}
                                                                                      {
                                                                                        label
                                                                                      }{" "}
                                                                                    </option>
                                                                                  ),
                                                                                )}{" "}
                                                                              </select>{" "}
                                                                            </div>
                                                                          )}

                                                                          {/* Computed Weight */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Computed
                                                                              Weight
                                                                              (lbs){" "}
                                                                            </label>{" "}
                                                                            <input
                                                                              type="text"
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                              value={
                                                                                computedWeight
                                                                              }
                                                                              readOnly
                                                                            />{" "}
                                                                          </div>

                                                                          {/* Goal */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Goal{" "}
                                                                            </label>{" "}
                                                                            <select
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                              value={
                                                                                set.goal ||
                                                                                ""
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                updateSupersetSet(
                                                                                  item._id,
                                                                                  sIdx,
                                                                                  setIdx,
                                                                                  "goal",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                            >
                                                                              {" "}
                                                                              <option value="">
                                                                                {" "}
                                                                                —Goal
                                                                                —{" "}
                                                                              </option>{" "}
                                                                              <option value="< 0.5 m/s (Absolute Strength)">
                                                                                {" "}
                                                                                &lt;
                                                                                0.5
                                                                                m/s
                                                                                (Absolute
                                                                                Strength){" "}
                                                                              </option>{" "}
                                                                              <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                                {" "}
                                                                                0.5
                                                                                -
                                                                                0.75
                                                                                m/s
                                                                                (Accelerative
                                                                                Strength){" "}
                                                                              </option>{" "}
                                                                              <option value="0.75 - 1 m/s (Strength Speed)">
                                                                                {" "}
                                                                                0.75
                                                                                -
                                                                                1
                                                                                m/s
                                                                                (Strength
                                                                                Speed){" "}
                                                                              </option>{" "}
                                                                              <option value="1 - 1.3 m/s (Speed Strength)">
                                                                                {" "}
                                                                                1
                                                                                -
                                                                                1.3
                                                                                m/s
                                                                                (Speed
                                                                                Strength){" "}
                                                                              </option>{" "}
                                                                              <option value="> 1.3 m/s (Starting Strength)">
                                                                                {" "}
                                                                                &gt;
                                                                                1.3
                                                                                m/s
                                                                                (Starting
                                                                                Strength){" "}
                                                                              </option>{" "}
                                                                              <option value="> 2 m/s (Speed)">
                                                                                {" "}
                                                                                &gt;
                                                                                2
                                                                                m/s
                                                                                (Speed){" "}
                                                                              </option>{" "}
                                                                            </select>{" "}
                                                                          </div>

                                                                          {/* Rest */}
                                                                          <div className="flex-1 min-w-28">
                                                                            {" "}
                                                                            <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                              {" "}
                                                                              Rest{" "}
                                                                            </label>{" "}
                                                                            <input
                                                                              type="text"
                                                                              className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                              value={
                                                                                set.rest ||
                                                                                ""
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                updateSupersetSet(
                                                                                  item._id,
                                                                                  sIdx,
                                                                                  setIdx,
                                                                                  "rest",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                              placeholder="Rest"
                                                                            />{" "}
                                                                          </div>
                                                                        </div>
                                                                        {/* Delete Btn */}
                                                                        <div className="">
                                                                          <button
                                                                            className="rounded hover:bg-white p-2"
                                                                            onClick={() =>
                                                                              deleteSupersetSet(
                                                                                item._id,
                                                                                sIdx,
                                                                                setIdx,
                                                                              )
                                                                            }
                                                                          >
                                                                            <RiDeleteBin4Line
                                                                              color="#666666"
                                                                              size={
                                                                                18
                                                                              }
                                                                            />
                                                                          </button>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    {/* Notes */}
                                                                    <div className="flex flex-col gap-2 border-b border-tblBorder pb-3 mb-">
                                                                      {" "}
                                                                      <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                        {" "}
                                                                        Notes{" "}
                                                                      </label>{" "}
                                                                      <div className="flex gap-1 items-center">
                                                                        {" "}
                                                                        <input
                                                                          type="text"
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.notes ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateSupersetSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "notes",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder="Notes"
                                                                        />{" "}
                                                                      </div>
                                                                    </div>
                                                                  </>
                                                                );
                                                              },
                                                            )}

                                                            <button
                                                              className="text-xs font-medium text-slate100 hover:text-dark group flex items-center gap-1"
                                                              onClick={() =>
                                                                addSupersetSet(
                                                                  item._id,
                                                                  sIdx,
                                                                )
                                                              }
                                                            >
                                                              <MdAdd color="#666666" />{" "}
                                                              Add Set
                                                            </button>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </div>
                                                  );
                                                },
                                              )
                                            )}

                                            {/* Add Exercise Form */}
                                            {showSupersetAddForm ===
                                            item._id ? (
                                              <div className="bg-bgBase border border-tblBorder rounded-14 p-4 mb-4">
                                                <label className="block text-sm font-medium mb-2">
                                                  Select Exercise
                                                </label>
                                                <div className="flex max-xl:flex-wrap gap-3">
                                                  <SingleSelectExerciseList
                                                    exercises={exerciseLibrary}
                                                    value={
                                                      selectedSupersetExerciseId ||
                                                      ""
                                                    }
                                                    onChange={
                                                      setSelectedSupersetExerciseId
                                                    }
                                                  />

                                                  <div className="flex items-end gap-2 mt-2">
                                                    <button
                                                      onClick={() =>
                                                        handleAddSupersetExercise(
                                                          item._id,
                                                        )
                                                      }
                                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex items-center gap-2"
                                                    >
                                                      <MdAdd
                                                        color="#fff"
                                                        size={18}
                                                      />{" "}
                                                      Add
                                                    </button>
                                                    <button
                                                      onClick={() =>
                                                        setShowSupersetAddForm(
                                                          null,
                                                        )
                                                      }
                                                      className="bg-white border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                                                    >
                                                      Cancel
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="flex max-sm:flex-col gap-4 sm:items-center">
                                                <button
                                                  onClick={() =>
                                                    setShowSupersetAddForm(
                                                      item._id,
                                                    )
                                                  }
                                                  className="pt-1 text-xs font-medium text-slate100 hover:text-dark group flex items-center gap-1"
                                                >
                                                  <MdAdd
                                                    color="#666"
                                                    size={18}
                                                  />{" "}
                                                  Add Exercise to Superset
                                                </button>

                                                {/* <button
                                                  onClick={() =>
                                                    setSSReorderMode((prev) =>
                                                      prev === item._id
                                                        ? null
                                                        : item._id,
                                                    )
                                                  }
                                                  className="pl-4 pr-6 py-2.5 max-sm:w-fit bg-white text-dark border border-tblBorder font-inter font-normal text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                                                >
                                                  <DotedSvg />{" "}
                                                  {ssreorderMode === item._id
                                                    ? "Done Reordering"
                                                    : "Reorder Exercises"}
                                                </button>
                              */}
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        {item.type === "circuit" && (
                                          <div className="space-y-2">
                                            {/* Reorder Mode */}
                                            {ccreorderMode ? (
                                              <div className="">
                                                <div className="flex items-center gap-3">
                                                  <div
                                                    className="p-2 rounded-lg border border-tblBorder bg-white
                                                 flex items-center
                                                  gap-1 text-dark text-xs font-medium flex-none"
                                                  >
                                                    <DotedSvg /> Reorder Mode
                                                  </div>
                                                  <span className="flex-1 bg-tblBorder h-px w-full"></span>
                                                </div>

                                                <div className="space-y-0.5 mt-3">
                                                  <DndContext
                                                    onDragEnd={(e) =>
                                                      handleCircuitReorderEnd(
                                                        e,
                                                        selectedDayInfo.weekIdx,
                                                        selectedDayInfo.dayIdx,
                                                        item._id,
                                                      )
                                                    }
                                                  >
                                                    {item.circuit?.exercises?.map(
                                                      (sup, sIdx) => (
                                                        <DroppableCCEX
                                                          key={sup._id}
                                                          id={String(sup._id)}
                                                        >
                                                          <DraggableCCEXItem
                                                            id={String(sup._id)}
                                                            itemIndex={sIdx}
                                                            item={sup}
                                                            displayName={
                                                              typeof sup.exercise_id ===
                                                              "object"
                                                                ? sup
                                                                    .exercise_id
                                                                    ?.title ||
                                                                  "Unnamed Exercise"
                                                                : exerciseLibrary.find(
                                                                    (ex) =>
                                                                      ex._id ===
                                                                      sup.exercise_id,
                                                                  )?.title ||
                                                                  "Unnamed Exercise"
                                                            }
                                                          />
                                                        </DroppableCCEX>
                                                      ),
                                                    )}
                                                  </DndContext>
                                                </div>
                                              </div>
                                            ) : (
                                              /* Normal Render Mode */
                                              item.circuit?.exercises?.map(
                                                (circ, sIdx) => {
                                                  const isOpen =
                                                    openCircuitExercise.itemId ===
                                                      item._id &&
                                                    openCircuitExercise.sIdx ===
                                                      sIdx;

                                                  const exerciseObj =
                                                    getExerciseObject(
                                                      circ.exercise_id,
                                                      exerciseLibrary,
                                                    );

                                                  return (
                                                    <div
                                                      key={
                                                        circ._id || circ.tempId
                                                      }
                                                      className="bg-tblHead border border-tblBorder rounded-10"
                                                    >
                                                      {/* Header */}
                                                      <div className="flex max-md:flex-col items-start gap-4 py-3 px-4">
                                                        <div className="max-md:w-full md:flex-1 flex md:items-center gap-4">
                                                          {/* Video Thumbnail + Preview */}

                                                          <div className="size-16 flex-none">
                                                            {" "}
                                                            {exerciseObj?.video_url && (
                                                              <div className="relative h-full">
                                                                {" "}
                                                                <img
                                                                  src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                                  alt="Video thumbnail"
                                                                  className="w-full h-full rounded-lg border object-cover"
                                                                />{" "}
                                                                <button
                                                                  className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2] text-white text-sm underline"
                                                                  onClick={(
                                                                    e,
                                                                  ) => {
                                                                    e.preventDefault();
                                                                    setVideoUrlToPlay(
                                                                      exerciseObj.video_url,
                                                                    );
                                                                  }}
                                                                >
                                                                  {" "}
                                                                  ▶{" "}
                                                                </button>{" "}
                                                              </div>
                                                            )}{" "}
                                                          </div>

                                                          <div className="w-full flex max-md:flex-col gap-4">
                                                            {/* Exercise Title */}
                                                            <div className="max-md:w-full max-xl:flex-1 xl:w-[60%]  flex flex-col gap-1.5">
                                                              {" "}
                                                              <label className="text-slate100 text-xs font-medium">
                                                                {" "}
                                                                Exercise{" "}
                                                              </label>{" "}
                                                              <p className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none">
                                                                {" "}
                                                                {exerciseObj?.title ||
                                                                  `Exercise ${sIdx + 1}`}{" "}
                                                              </p>{" "}
                                                            </div>

                                                            {/* 1RM Input */}
                                                            <div className="max-md:w-full max-xl:flex-1 xl:w-[40%]  flex flex-col gap-1.5">
                                                              <label className="text-slate100 text-xs font-medium">
                                                                1RM:
                                                              </label>
                                                              <input
                                                                type="number"
                                                                placeholder="lbs"
                                                                className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none"
                                                                value={
                                                                  circ.one_rm ||
                                                                  ""
                                                                }
                                                                onChange={(e) =>
                                                                  updateCircuitExerciseField(
                                                                    item._id, // circuit id
                                                                    sIdx, // exercise index inside circuit
                                                                    "one_rm", // field name
                                                                    e.target
                                                                      .value, // new value
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="flex-none max-md:ml-auto flex gap-3 xl:pt-3">
                                                          <button
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleDeleteCircuitExercise(
                                                                item._id,
                                                                circ._id ||
                                                                  circ.tempId,
                                                              );
                                                            }}
                                                            className="rounded hover:bg-white p-2"
                                                          >
                                                            <RiDeleteBin4Line
                                                              color="#666666"
                                                              size={18}
                                                            />
                                                          </button>
                                                          <div>
                                                            <button
                                                              className="rounded hover:bg-gray-200 p-2"
                                                              onClick={() =>
                                                                setOpenCircuitExercise(
                                                                  isOpen
                                                                    ? {
                                                                        itemId:
                                                                          null,
                                                                        sIdx: null,
                                                                      }
                                                                    : {
                                                                        itemId:
                                                                          item._id,
                                                                        sIdx,
                                                                      },
                                                                )
                                                              }
                                                            >
                                                              <IoIosArrowDown
                                                                color="#666666"
                                                                size={18}
                                                                className={`${isOpen ? "rotate-180" : ""} transition-all`}
                                                              />
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      {/* Collapsible Content */}
                                                      {isOpen && (
                                                        <div className="px-3 py-2 bg-white text-sm rounded-b-10 border-t">
                                                          {(
                                                            circ.sets || []
                                                          ).map(
                                                            (set, setIdx) => {
                                                              let computedWeight =
                                                                "";
                                                              if (
                                                                set.unit ===
                                                                  "%" &&
                                                                circ.one_rm
                                                              ) {
                                                                /* computedWeight = Math.round(
                                                              (circ.one_rm || 0) * (set.weight || 0) / 100
                                                            );*/

                                                                const rawWeight =
                                                                  ((circ.one_rm ||
                                                                    0) *
                                                                    (set.weight ||
                                                                      0)) /
                                                                  100;
                                                                // console.log("💡 % logic hit:", { rawWeight, one_rm: sup.one_rm, setWeight: set.weight });
                                                                computedWeight =
                                                                  Math.ceil(
                                                                    rawWeight /
                                                                      5,
                                                                  ) * 5;
                                                              } else if (
                                                                set.unit ===
                                                                "lbs"
                                                              ) {
                                                                computedWeight =
                                                                  set.weight ||
                                                                  "";
                                                              }

                                                              return (
                                                                <div
                                                                  key={setIdx}
                                                                  className="flex flex-col gap-3 "
                                                                >
                                                                  <div className="flex items-start gap-3 bg-tblHead border border-tblBorder rounded-10 p-4">
                                                                    <div className="flex flex-wrap gap-3 items-center text-sm">
                                                                      {/* Reps */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Reps{" "}
                                                                        </label>{" "}
                                                                        <input
                                                                          type="number"
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.reps ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateCircuitSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "reps",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder="Reps"
                                                                        />{" "}
                                                                      </div>
                                                                      {/* Weight */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Weight{" "}
                                                                        </label>{" "}
                                                                        <input
                                                                          type="number"
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.weight ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateCircuitSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "weight",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder="Weight"
                                                                        />{" "}
                                                                      </div>

                                                                      {/* Unit */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Unit{" "}
                                                                        </label>{" "}
                                                                        <select
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.unit ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateCircuitSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "unit",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                        >
                                                                          {" "}
                                                                          <option value="%">
                                                                            {" "}
                                                                            %{" "}
                                                                          </option>{" "}
                                                                          <option value="lbs">
                                                                            {" "}
                                                                            lbs{" "}
                                                                          </option>{" "}
                                                                          <option value="hide">
                                                                            {" "}
                                                                            hide{" "}
                                                                          </option>{" "}
                                                                          <option value="time">
                                                                            {" "}
                                                                            Time{" "}
                                                                          </option>{" "}
                                                                        </select>{" "}
                                                                      </div>

                                                                      {/* Time */}
                                                                      {set.unit ===
                                                                        "time" && (
                                                                        <div className="flex-1 min-w-28">
                                                                          {" "}
                                                                          <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                            {" "}
                                                                            Time{" "}
                                                                          </label>{" "}
                                                                          <select
                                                                            className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                            value={
                                                                              set.time ||
                                                                              ""
                                                                            }
                                                                            onChange={(
                                                                              e,
                                                                            ) =>
                                                                              updateCircuitSet(
                                                                                item._id,
                                                                                sIdx,
                                                                                setIdx,
                                                                                "time",
                                                                                e
                                                                                  .target
                                                                                  .value,
                                                                              )
                                                                            }
                                                                          >
                                                                            {" "}
                                                                            <option value="">
                                                                              {" "}
                                                                              Select{" "}
                                                                            </option>{" "}
                                                                            {TIME_OPTIONS.map(
                                                                              (
                                                                                label,
                                                                              ) => (
                                                                                <option
                                                                                  key={
                                                                                    label
                                                                                  }
                                                                                  value={
                                                                                    label
                                                                                  }
                                                                                >
                                                                                  {" "}
                                                                                  {
                                                                                    label
                                                                                  }{" "}
                                                                                </option>
                                                                              ),
                                                                            )}{" "}
                                                                          </select>{" "}
                                                                        </div>
                                                                      )}
                                                                      {/* Computed Weight */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Computed
                                                                          Weight
                                                                          (lbs){" "}
                                                                        </label>{" "}
                                                                        <input
                                                                          type="text"
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            computedWeight
                                                                          }
                                                                          readOnly
                                                                        />{" "}
                                                                      </div>
                                                                      {/* Goal */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Goal{" "}
                                                                        </label>{" "}
                                                                        <select
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.goal ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateCircuitSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "goal",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                        >
                                                                          {" "}
                                                                          <option value="">
                                                                            {" "}
                                                                            —
                                                                            Goal
                                                                            —{" "}
                                                                          </option>{" "}
                                                                          <option value="< 0.5 m/s (Absolute Strength)">
                                                                            {" "}
                                                                            &lt;
                                                                            0.5
                                                                            m/s
                                                                            (Absolute
                                                                            Strength){" "}
                                                                          </option>{" "}
                                                                          <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                            {" "}
                                                                            0.5
                                                                            -
                                                                            0.75
                                                                            m/s
                                                                            (Accelerative
                                                                            Strength){" "}
                                                                          </option>{" "}
                                                                          <option value="0.75 - 1 m/s (Strength Speed)">
                                                                            {" "}
                                                                            0.75
                                                                            - 1
                                                                            m/s
                                                                            (Strength
                                                                            Speed){" "}
                                                                          </option>{" "}
                                                                          <option value="1 - 1.3 m/s (Speed Strength)">
                                                                            {" "}
                                                                            1 -
                                                                            1.3
                                                                            m/s
                                                                            (Speed
                                                                            Strength){" "}
                                                                          </option>{" "}
                                                                          <option value="> 1.3 m/s (Starting Strength)">
                                                                            {" "}
                                                                            &gt;
                                                                            1.3
                                                                            m/s
                                                                            (Starting
                                                                            Strength){" "}
                                                                          </option>{" "}
                                                                          <option value="> 2 m/s (Speed)">
                                                                            {" "}
                                                                            &gt;
                                                                            2
                                                                            m/s
                                                                            (Speed){" "}
                                                                          </option>{" "}
                                                                        </select>{" "}
                                                                      </div>
                                                                      {/* Rest */}
                                                                      <div className="flex-1 min-w-28">
                                                                        {" "}
                                                                        <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                          {" "}
                                                                          Rest{" "}
                                                                        </label>{" "}
                                                                        <input
                                                                          type="text"
                                                                          className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-xs outline-none"
                                                                          value={
                                                                            set.rest ||
                                                                            ""
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            updateCircuitSet(
                                                                              item._id,
                                                                              sIdx,
                                                                              setIdx,
                                                                              "rest",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder="Rest"
                                                                        />{" "}
                                                                      </div>
                                                                    </div>
                                                                    <div>
                                                                      {" "}
                                                                      <button
                                                                        className="rounded hover:bg-white p-2"
                                                                        onClick={() =>
                                                                          deleteCircuitSet(
                                                                            item._id,
                                                                            sIdx,
                                                                            setIdx,
                                                                          )
                                                                        }
                                                                      >
                                                                        {" "}
                                                                        <RiDeleteBin4Line
                                                                          color="#666666"
                                                                          size={
                                                                            18
                                                                          }
                                                                        />{" "}
                                                                      </button>{" "}
                                                                    </div>
                                                                  </div>

                                                                  {/* Notes */}
                                                                  <div className="flex flex-col gap-2 border-b border-tblBorder pb-6 mb-6">
                                                                    {" "}
                                                                    <label className="block text-[#99A1AF] text-[10px] font-medium">
                                                                      {" "}
                                                                      Notes{" "}
                                                                    </label>{" "}
                                                                    <input
                                                                      type="text"
                                                                      className="w-full px-2 py-1.5 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none"
                                                                      value={
                                                                        set.notes ||
                                                                        ""
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        updateCircuitSet(
                                                                          item._id,
                                                                          sIdx,
                                                                          setIdx,
                                                                          "notes",
                                                                          e
                                                                            .target
                                                                            .value,
                                                                        )
                                                                      }
                                                                      placeholder="Notes"
                                                                    />{" "}
                                                                  </div>
                                                                </div>
                                                              );
                                                            },
                                                          )}

                                                          <button
                                                            className="text-xs font-medium text-slate100 hover:text-dark group flex items-center gap-1"
                                                            onClick={() =>
                                                              addCircuitSet(
                                                                item._id,
                                                                sIdx,
                                                              )
                                                            }
                                                          >
                                                            <MdAdd
                                                              color="#666666"
                                                              size={18}
                                                              className="group-hover:!text-black"
                                                            />{" "}
                                                            Add Set
                                                          </button>
                                                        </div>
                                                      )}
                                                    </div>
                                                  );
                                                },
                                              )
                                            )}

                                            {/* Add Exercise Form */}
                                            {showCircuitAddForm === item._id ? (
                                              <div className="bg-bgBase border border-tblBorder rounded-14 p-4 mb-4">
                                                <label className="block text-sm font-medium mb-2">
                                                  Select Exercise
                                                </label>
                                                <div className="flex max-xl:flex-wrap gap-3">
                                                  <SingleSelectExerciseList
                                                    exercises={exerciseLibrary}
                                                    value={
                                                      selectedCircuitExerciseId
                                                    }
                                                    onChange={
                                                      setSelectedCircuitExerciseId
                                                    }
                                                  />

                                                  <div className="flex items-end gap-3">
                                                    <button
                                                      onClick={() =>
                                                        handleAddCircuitExercise(
                                                          item._id,
                                                        )
                                                      }
                                                      className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black inline-flex items-center gap-2"
                                                    >
                                                      <MdAdd
                                                        color="#fff"
                                                        size={18}
                                                      />{" "}
                                                      Add
                                                    </button>
                                                    <button
                                                      onClick={() =>
                                                        setShowCircuitAddForm(
                                                          null,
                                                        )
                                                      }
                                                      className="pl-4 pr-6 py-2.5 bg-white text-dark border border-tblBorder font-inter font-medium text-sm leading-tight rounded-lg hover:bg-gray-200"
                                                    >
                                                      Cancel
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="flex max-sm:flex-col gap-4 sm:items-center">
                                                <button
                                                  onClick={() =>
                                                    setShowCircuitAddForm(
                                                      item._id,
                                                    )
                                                  }
                                                  className="pt-1 text-xs font-medium text-slate100 hover:text-dark group flex items-center gap-1"
                                                >
                                                  <MdAdd
                                                    color="#666666"
                                                    size={18}
                                                    className="group-hover:!text-black"
                                                  />{" "}
                                                  Add Exercise to Circuit
                                                </button>

                                                {/*<button
                                                  onClick={() =>
                                                    setCCReorderMode(
                                                      (prev) => !prev,
                                                    )
                                                  }
                                                  className="pl-4 pr-6 py-2.5 max-sm:w-fit bg-white text-dark border border-tblBorder font-inter font-normal text-sm leading-tight rounded-lg flex items-center gap-1.5 hover:bg-gray-200"
                                                >
                                                  <DotedSvg />{" "}
                                                  {ccreorderMode
                                                    ? "Done Reordering"
                                                    : "Reorder Exercises"}
                                                </button>
                                                */}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                            </div>

                            {/* Master training focus loaded here */}
                            {filteredWeeks[selectedDayInfo.weekIdx]?.days?.[
                              selectedDayInfo.dayIdx
                            ]?.items?.length === 0 &&
                              items.length === 0 && (
                                <div className="font-inter mt-6">
                                  <h2 className="font-inter text-lg font-medium text-dark mb-4">
                                    Start by choosing a training workout
                                    template
                                  </h2>

                                  {loading ? (
                                    <div className="p-2 bg-gray-100 text-center rounded-10">
                                      <p className="text-gray-600 font-normal">
                                        Loading available templates...
                                      </p>
                                    </div>
                                  ) : error ? (
                                    <div className="p-2 bg-red-200 text-center rounded-10">
                                      <p className="text-red-500 font-normal">
                                        {error}
                                      </p>
                                    </div>
                                  ) : trainingFocuses.length === 0 ? (
                                    <div className="p-2 bg-red-200 text-center rounded-10">
                                      <p className="text-gray-500 font-normal">
                                        No training workout templates available.
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="overflow-x-auto">
                                      {/* Search */}
                                      <div className="mb-4 relative">
                                        <input
                                          type="text"
                                          value={searchTerm}
                                          onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setCurrentPage(1);
                                          }}
                                          placeholder="Search by title or phase..."
                                          className="w-full bg-white border border-tblBorder !pl-10 py-1.5 px-3 rounded-lg text-dark font-inter font-medium text-base outline-none placeholder:font-inter placeholder:font-normal"
                                        />
                                        <span className="absolute top-1/2 -translate-y-1/2 left-3">
                                          <CiSearch color="#666" size={18} />
                                        </span>
                                      </div>

                                      {/* Table */}
                                      <div className="min-w-full text-sm text-left">
                                        {/* <thead className="bg-gray-100 font-medium">
                                          <tr>
                                            <th className="p-3">
                                              Training Focus
                                            </th>
                                            <th className="p-3">Phase</th>
                                            <th className="p-3">Items</th>
                                            <th className="p-3">Actions</th>
                                          </tr>
                                        </thead> */}
                                        <div className="space-y-3">
                                          {paginatedTemplates.map(
                                            (template) => (
                                              <div
                                                key={template._id}
                                                className=" border border-tblBorder rounded-14"
                                              >
                                                <div
                                                  onClick={() =>
                                                    toggleExpand(template._id)
                                                  }
                                                  className="cursor-pointer flex flex-nowrap justify-between gap-x-5 gap-y-2 p-4"
                                                >
                                                  <div>
                                                    <span className="block text-dark font-medium max-[430px]:text-xs text-sm whitespace-pre-wrap mb-0.5">
                                                      {template.training_focus}
                                                    </span>
                                                    <span className="block text-slate100 font-medium max-[430px]:text-xs text-xs whitespace-pre-wrap">
                                                      {template.training_phase}
                                                    </span>
                                                  </div>

                                                  <div className="flex-none flex items-center gap-2">
                                                    <span className="text-slate100 font-medium text-xs md:text-sm">
                                                      {template.items?.length ||
                                                        0}{" "}
                                                      item(s)
                                                    </span>

                                                    <button className="rounded hover:bg-bgBase p-1 md:p-2">
                                                      <IoIosArrowDown
                                                        color="#666666"
                                                        size={18}
                                                        className={`${expandedRow === template._id ? "rotate-180" : ""} transition-all`}
                                                      />
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Expanded Row */}
                                                {expandedRow ===
                                                  template._id && (
                                                  <div>
                                                    <div className="bg-bgBase rounded-b-14 pt-3 pb-6 px-4">
                                                      {template.items?.length >
                                                      0 ? (
                                                        <>
                                                          <div className="overflow-auto show-scrollbar">
                                                            <div className="rounded-10 border border-tblBorder">
                                                              <table className="w-full min-w-[450px] table-radius font-inter text-sm">
                                                                <thead className="bg-tblHead border-b border-tblBorder">
                                                                  <tr className="text-slate100 text-xs font-medium">
                                                                    {" "}
                                                                    <th className="px-4 py-3 text-xs">
                                                                      {" "}
                                                                      #{" "}
                                                                    </th>{" "}
                                                                    <th className="px-4 py-3 text-xs">
                                                                      {" "}
                                                                      Type{" "}
                                                                    </th>{" "}
                                                                    <th className="px-4 py-3 text-xs">
                                                                      {" "}
                                                                      Title{" "}
                                                                    </th>{" "}
                                                                    <th className="px-4 py-3 text-xs">
                                                                      {" "}
                                                                      Details{" "}
                                                                    </th>{" "}
                                                                  </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-[#E5E5E5] bg-white">
                                                                  {" "}
                                                                  {template.items.map(
                                                                    (
                                                                      item,
                                                                      index,
                                                                    ) => {
                                                                      let type =
                                                                        item.type;
                                                                      let title =
                                                                        "";
                                                                      let detail =
                                                                        "";
                                                                      if (
                                                                        type ===
                                                                        "exercise"
                                                                      ) {
                                                                        title =
                                                                          item
                                                                            .exercise
                                                                            .exercise_id
                                                                            ?.title ||
                                                                          "Untitled";
                                                                      } else if (
                                                                        type ===
                                                                        "superset"
                                                                      ) {
                                                                        title =
                                                                          item
                                                                            .superset
                                                                            .title ||
                                                                          "Untitled";
                                                                        detail =
                                                                          item.superset.exercises
                                                                            .map(
                                                                              (
                                                                                ex,
                                                                              ) =>
                                                                                ex
                                                                                  .exercise_id
                                                                                  ?.title ||
                                                                                "Exercise",
                                                                            )
                                                                            .join(
                                                                              ", ",
                                                                            );
                                                                      } else if (
                                                                        type ===
                                                                        "circuit"
                                                                      ) {
                                                                        title =
                                                                          item
                                                                            .circuit
                                                                            .title ||
                                                                          "Untitled";
                                                                        detail =
                                                                          item.circuit.exercises
                                                                            .map(
                                                                              (
                                                                                ex,
                                                                              ) =>
                                                                                ex
                                                                                  .exercise_id
                                                                                  ?.title ||
                                                                                "Exercise",
                                                                            )
                                                                            .join(
                                                                              ", ",
                                                                            );
                                                                      }
                                                                      return (
                                                                        <tr
                                                                          key={
                                                                            index
                                                                          }
                                                                          className="border-t"
                                                                        >
                                                                          {" "}
                                                                          <td className="py-3 px-4 text-slate100 font-normal">
                                                                            {" "}
                                                                            {index +
                                                                              1}{" "}
                                                                          </td>{" "}
                                                                          <td className="py-3 px-4 text-slate100 font-normal capitalize">
                                                                            {" "}
                                                                            {
                                                                              type
                                                                            }{" "}
                                                                          </td>{" "}
                                                                          <td className="py-3 px-4 text-dark font-medium">
                                                                            {" "}
                                                                            {
                                                                              title
                                                                            }{" "}
                                                                          </td>{" "}
                                                                          <td className="py-3 px-4 text-slate100 font-normal">
                                                                            {" "}
                                                                            {detail ||
                                                                              "-"}{" "}
                                                                          </td>{" "}
                                                                        </tr>
                                                                      );
                                                                    },
                                                                  )}{" "}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                          <button
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleUseFocusTemplate(
                                                                template,
                                                              );
                                                            }}
                                                            className="w-full px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black flex justify-center items-center gap-2 mt-3"
                                                          >
                                                            {" "}
                                                            Use Template{" "}
                                                            <FaChevronRight color="FFF" />{" "}
                                                          </button>
                                                        </>
                                                      ) : (
                                                        <p className="text-gray-500">
                                                          {" "}
                                                          No items in this
                                                          template.{" "}
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      </div>

                                      {/* Pagination */}
                                      <div className="flex max-sm:flex-col justify-between items-center mt-4">
                                        <button
                                          disabled={currentPage === 1}
                                          onClick={() =>
                                            setCurrentPage((prev) => prev - 1)
                                          }
                                          className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                            currentPage === 1
                                              ? "cursor-not-allowed"
                                              : "text-black"
                                          }`}
                                        >
                                          <MdKeyboardArrowLeft size={20} />{" "}
                                          Previous
                                        </button>
                                        <span className="text-dark font-inter font-normal text-sm">
                                          Page {currentPage} of {totalPages}
                                        </span>
                                        <button
                                          disabled={currentPage === totalPages}
                                          onClick={() =>
                                            setCurrentPage((prev) => prev + 1)
                                          }
                                          className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                            currentPage === totalPages
                                              ? "cursor-not-allowed"
                                              : "text-black"
                                          }`}
                                        >
                                          Next{" "}
                                          <MdKeyboardArrowRight size={20} />
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {videoUrlToPlay && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-2xl relative">
            <button
              onClick={() => setVideoUrlToPlay(null)}
              className="absolute top-2 right-3 p-2 rounded-lg bg-dark flex justify-center items-center hover:bg-black/80"
            >
              <RxCross2 color="#fff" />
            </button>
            <iframe
              width="100%"
              height="400"
              src={videoUrlToPlay.replace("watch?v=", "embed/")}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Exercise Video"
              className="rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const DraggableEXItem = ({ itemIndex, id, item, displayName }) => {
  const [dragMode, setDragMode] = useState(true);
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none",
      }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...(dragMode ? listeners : {})}
      style={style}
      className="bg-tblHead border bordere-tblBorder py-2 px-3 text-dark text-sm font-medium rounded-10"
    >
      <h4 className="font-semibold text-sm leading-tight m-0">{displayName}</h4>
    </div>
  );
};

const DroppableEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-1 py-1 rounded-md`}
    >
      {children}
    </div>
  );
};

const DroppableSSEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-1 py-1 rounded-md`} // ↓ reduced padding
    >
      {children}
    </div>
  );
};

export const DraggableSSEXItem = ({ itemIndex, id, item, displayName }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px", // small gap between items
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className="bg-tblHead border bordere-tblBorder py-2 px-3 text-dark text-sm font-medium rounded-10"
    >
      <h4 className="font-semibold text-sm leading-tight m-0">{displayName}</h4>
    </div>
  );
};

const DroppableCCEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-1 py-1 rounded-md`} // ↓ reduced padding
    >
      {children}
    </div>
  );
};

export const DraggableCCEXItem = ({ itemIndex, id, item, displayName }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px", // small gap between items
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className="bg-tblHead border bordere-tblBorder py-2 px-3 text-dark text-sm font-medium rounded-10"
    >
      <h4 className="font-semibold text-sm leading-tight m-0">{displayName}</h4>
    </div>
  );
};
